//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseClient {
    private store:any;
    constructor(conf:any) {
       this.store = conf.$auth;
      
    }
 
    protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
      var token="";
    
        if (this.store.$state && this.store.$state.loggedIn)
             token = this.store.strategy.token.get();
        options.headers = {
            ...options.headers,
            Authorization: token,
        };
        return Promise.resolve(options);
    };

    protected transformResult(url: string, response: Response, processor: (response: Response) => any): Promise<any> {
        return processor(response);
    }
}

export class CoutHoraireClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: CoutHoraireCommand): Promise<Cout> {
        let url_ = this.baseUrl + "/api/CoutHoraire/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<Cout> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Cout.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = CommandError.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cout>(null as any);
    }

    getByUserId(userId: string): Promise<CoutHoraireViewModel[]> {
        let url_ = this.baseUrl + "/api/CoutHoraire/GetByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByUserId(_response));
        });
    }

    protected processGetByUserId(response: Response): Promise<CoutHoraireViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoutHoraireViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = CommandError.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoutHoraireViewModel[]>(null as any);
    }

    getById(coutId: string): Promise<CoutHoraireViewModel> {
        let url_ = this.baseUrl + "/api/CoutHoraire/GetById/{coutId}";
        if (coutId === undefined || coutId === null)
            throw new Error("The parameter 'coutId' must be defined.");
        url_ = url_.replace("{coutId}", encodeURIComponent("" + coutId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CoutHoraireViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoutHoraireViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = CommandError.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoutHoraireViewModel>(null as any);
    }

    update(id: string | null, command: CoutHoraireCommand): Promise<Cout> {
        let url_ = this.baseUrl + "/api/CoutHoraire/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<Cout> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Cout.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = CommandError.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cout>(null as any);
    }

    delete(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CoutHoraire/Delete/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DashboardClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getResumeNeedValidateSheets(): Promise<GetResumeNeedValidateResponseModel> {
        let url_ = this.baseUrl + "/api/Dashboard/GetResumeNeedValidateSheets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResumeNeedValidateSheets(_response));
        });
    }

    protected processGetResumeNeedValidateSheets(response: Response): Promise<GetResumeNeedValidateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResumeNeedValidateResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetResumeNeedValidateResponseModel>(null as any);
    }

    getRefuseValidateSheets(): Promise<GetRefuseTimeSheetResponseModel> {
        let url_ = this.baseUrl + "/api/Dashboard/GetRefuseValidateSheets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRefuseValidateSheets(_response));
        });
    }

    protected processGetRefuseValidateSheets(response: Response): Promise<GetRefuseTimeSheetResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRefuseTimeSheetResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRefuseTimeSheetResponseModel>(null as any);
    }
}

export class ExportExterneClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getColumns(): Promise<ExportTableDefinitionResponse> {
        let url_ = this.baseUrl + "/api/ExportExterne/GetColumns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "OPTIONS",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetColumns(_response));
        });
    }

    protected processGetColumns(response: Response): Promise<ExportTableDefinitionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportTableDefinitionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportTableDefinitionResponse>(null as any);
    }

    exportCSV(startDate: Date | undefined, endDate: Date | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportExterne/ExportCSV?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportCSV(_response));
        });
    }

    protected processExportCSV(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getData(startDate: Date | undefined, endDate: Date | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<ExportTableResponse> {
        let url_ = this.baseUrl + "/api/ExportExterne/GetData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetData(_response));
        });
    }

    protected processGetData(response: Response): Promise<ExportTableResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportTableResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportTableResponse>(null as any);
    }
}

export class ClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    images(entrepriseId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Images/{entrepriseId}.png";
        if (entrepriseId === undefined || entrepriseId === null)
            throw new Error("The parameter 'entrepriseId' must be defined.");
        url_ = url_.replace("{entrepriseId}", encodeURIComponent("" + entrepriseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImages(_response));
        });
    }

    protected processImages(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MiscClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    launchMigration(pwd: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Misc/LaunchMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pwd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLaunchMigration(_response));
        });
    }

    protected processLaunchMigration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setupApplication(pwd: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Misc/SetupApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pwd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetupApplication(_response));
        });
    }

    protected processSetupApplication(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    glitChip(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Misc/GlitChip";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGlitChip(_response));
        });
    }

    protected processGlitChip(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    glitChipAnonyme(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Misc/GlitChipAnonyme";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGlitChipAnonyme(_response));
        });
    }

    protected processGlitChipAnonyme(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjetClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getNextNumeroProjet(): Promise<string> {
        let url_ = this.baseUrl + "/api/Projet/GetNextNumeroProjet";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNextNumeroProjet(_response));
        });
    }

    protected processGetNextNumeroProjet(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getById(projectId: string | null): Promise<ProjectViewModel> {
        let url_ = this.baseUrl + "/api/Projet/GetById/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ProjectViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectViewModel>(null as any);
    }

    uploadProjectExcelFile(formFile: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projet/UploadProjectExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadProjectExcelFile(_response));
        });
    }

    protected processUploadProjectExcelFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    download(status: ProjectStatus | null | undefined, clients: string[] | null | undefined, tags: string[] | null | undefined, isFacturable: boolean | null | undefined, hasTaskOpened: boolean | null | undefined, startWeek: Date | null | undefined, endWeek: Date | null | undefined, text: string | null | undefined, includeDeleted: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projet/Download?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (clients !== undefined && clients !== null)
            clients && clients.forEach(item => { url_ += "Clients=" + encodeURIComponent("" + item) + "&"; });
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (isFacturable !== undefined && isFacturable !== null)
            url_ += "isFacturable=" + encodeURIComponent("" + isFacturable) + "&";
        if (hasTaskOpened !== undefined && hasTaskOpened !== null)
            url_ += "hasTaskOpened=" + encodeURIComponent("" + hasTaskOpened) + "&";
        if (startWeek !== undefined && startWeek !== null)
            url_ += "startWeek=" + encodeURIComponent(startWeek ? "" + startWeek.toISOString() : "") + "&";
        if (endWeek !== undefined && endWeek !== null)
            url_ += "endWeek=" + encodeURIComponent(endWeek ? "" + endWeek.toISOString() : "") + "&";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getProjetsForInput(userId: string | null | undefined, text: string | null | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<GetProjetsForInputResponse> {
        let url_ = this.baseUrl + "/api/Projet/GetProjetsForInput?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjetsForInput(_response));
        });
    }

    protected processGetProjetsForInput(response: Response): Promise<GetProjetsForInputResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjetsForInputResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProjetsForInputResponse>(null as any);
    }

    list(status: ProjectStatus | null | undefined, clients: string[] | null | undefined, tags: string[] | null | undefined, isFacturable: boolean | null | undefined, hasTaskOpened: boolean | null | undefined, startWeek: Date | null | undefined, endWeek: Date | null | undefined, text: string | null | undefined, includeDeleted: boolean | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<PagedResultOfProjectViewModel> {
        let url_ = this.baseUrl + "/api/Projet/List?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (clients !== undefined && clients !== null)
            clients && clients.forEach(item => { url_ += "Clients=" + encodeURIComponent("" + item) + "&"; });
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (isFacturable !== undefined && isFacturable !== null)
            url_ += "isFacturable=" + encodeURIComponent("" + isFacturable) + "&";
        if (hasTaskOpened !== undefined && hasTaskOpened !== null)
            url_ += "hasTaskOpened=" + encodeURIComponent("" + hasTaskOpened) + "&";
        if (startWeek !== undefined && startWeek !== null)
            url_ += "startWeek=" + encodeURIComponent(startWeek ? "" + startWeek.toISOString() : "") + "&";
        if (endWeek !== undefined && endWeek !== null)
            url_ += "endWeek=" + encodeURIComponent(endWeek ? "" + endWeek.toISOString() : "") + "&";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<PagedResultOfProjectViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProjectViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfProjectViewModel>(null as any);
    }

    tasks(projectId: string, statusTask: StatusTask | null | undefined, text: string | null | undefined, includeDeleted: boolean | undefined): Promise<TaskProjectViewModel[]> {
        let url_ = this.baseUrl + "/api/Projet/{projectId}/Tasks?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (statusTask !== undefined && statusTask !== null)
            url_ += "StatusTask=" + encodeURIComponent("" + statusTask) + "&";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTasks(_response));
        });
    }

    protected processTasks(response: Response): Promise<TaskProjectViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskProjectViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskProjectViewModel[]>(null as any);
    }

    documents(projectId: string): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/Projet/{projectId}/Documents";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDocuments(_response));
        });
    }

    protected processDocuments(response: Response): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentModel[]>(null as any);
    }

    create(command: ProjetCommand): Promise<ProjetReponse> {
        let url_ = this.baseUrl + "/api/Projet/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjetReponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjetReponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = CommandError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjetReponse>(null as any);
    }

    update(id: string | null, command: ProjetCommand): Promise<Project> {
        let url_ = this.baseUrl + "/api/Projet/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<Project> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Project.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Project>(null as any);
    }

    addOrUpdateComment(id: string | null, command: CommentCommand): Promise<Project> {
        let url_ = this.baseUrl + "/api/Projet/AddOrUpdateComment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddOrUpdateComment(_response));
        });
    }

    protected processAddOrUpdateComment(response: Response): Promise<Project> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Project.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Project>(null as any);
    }

    addTask(id: string, command: TaskProjectCommand): Promise<TaskProject> {
        let url_ = this.baseUrl + "/api/Projet/{id}/AddTask";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddTask(_response));
        });
    }

    protected processAddTask(response: Response): Promise<TaskProject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskProject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskProject>(null as any);
    }

    addOrUpdateTask(id: string, taskId: string | null, command: TaskProjectCommand): Promise<TaskProject> {
        let url_ = this.baseUrl + "/api/Projet/{id}/AddOrUpdateTask/{taskId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddOrUpdateTask(_response));
        });
    }

    protected processAddOrUpdateTask(response: Response): Promise<TaskProject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskProject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskProject>(null as any);
    }

    deleteTask(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projet/DeleteTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTask(_response));
        });
    }

    protected processDeleteTask(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projet/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ReferentielClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    roles(): Promise<ReferentielStringViewModel[]> {
        let url_ = this.baseUrl + "/api/Referentiel/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles(_response));
        });
    }

    protected processRoles(response: Response): Promise<ReferentielStringViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentielStringViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentielStringViewModel[]>(null as any);
    }

    projectStatus(): Promise<ReferentielStringViewModel[]> {
        let url_ = this.baseUrl + "/api/Referentiel/ProjectStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProjectStatus(_response));
        });
    }

    protected processProjectStatus(response: Response): Promise<ReferentielStringViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentielStringViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentielStringViewModel[]>(null as any);
    }

    taskStatus(): Promise<ReferentielStringViewModel[]> {
        let url_ = this.baseUrl + "/api/Referentiel/TaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskStatus(_response));
        });
    }

    protected processTaskStatus(response: Response): Promise<ReferentielStringViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentielStringViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentielStringViewModel[]>(null as any);
    }

    timeSheetStatus(): Promise<ReferentielStringViewModel[]> {
        let url_ = this.baseUrl + "/api/Referentiel/TimeSheetStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTimeSheetStatus(_response));
        });
    }

    protected processTimeSheetStatus(response: Response): Promise<ReferentielStringViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentielStringViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentielStringViewModel[]>(null as any);
    }
}

export class ReportingClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getReportsUser(startDate: Date | undefined, endDate: Date | null | undefined, userIds: string[] | null | undefined): Promise<WeekReportUtilisateurResponse> {
        let url_ = this.baseUrl + "/api/Reporting/GetReportsUser?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReportsUser(_response));
        });
    }

    protected processGetReportsUser(response: Response): Promise<WeekReportUtilisateurResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeekReportUtilisateurResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeekReportUtilisateurResponse>(null as any);
    }

    downloadReportUser(startDate: Date | undefined, endDate: Date | null | undefined, userIds: string[] | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reporting/DownloadReportUser?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadReportUser(_response));
        });
    }

    protected processDownloadReportUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadReportProject(grouping: string | null, criterias: ReportsCriteria): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reporting/DownloadReportProject";
        if (grouping === undefined || grouping === null)
            throw new Error("The parameter 'grouping' must be defined.");
        url_ = url_.replace("{grouping}", encodeURIComponent("" + grouping));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criterias);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadReportProject(_response));
        });
    }

    protected processDownloadReportProject(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadReportTask(grouping: string | null, criterias: ReportsCriteria): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reporting/DownloadReportTask";
        if (grouping === undefined || grouping === null)
            throw new Error("The parameter 'grouping' must be defined.");
        url_ = url_.replace("{grouping}", encodeURIComponent("" + grouping));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criterias);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadReportTask(_response));
        });
    }

    protected processDownloadReportTask(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getReportsGroupByProjet(grouping: string | null, criterias: ReportsCriteria): Promise<GroupingProject[]> {
        let url_ = this.baseUrl + "/api/Reporting/GetReportsGroupByProjet";
        if (grouping === undefined || grouping === null)
            throw new Error("The parameter 'grouping' must be defined.");
        url_ = url_.replace("{grouping}", encodeURIComponent("" + grouping));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criterias);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReportsGroupByProjet(_response));
        });
    }

    protected processGetReportsGroupByProjet(response: Response): Promise<GroupingProject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupingProject.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupingProject[]>(null as any);
    }
}

export class SettingsClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    settings(): Promise<SettingsViewModel> {
        let url_ = this.baseUrl + "/api/Settings/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSettings(_response));
        });
    }

    protected processSettings(response: Response): Promise<SettingsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingsViewModel>(null as any);
    }

    featuresOptions(): Promise<SettingFeaturesOption[]> {
        let url_ = this.baseUrl + "/api/Settings/FeaturesOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "OPTIONS",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFeaturesOptions(_response));
        });
    }

    protected processFeaturesOptions(response: Response): Promise<SettingFeaturesOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingFeaturesOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingFeaturesOption[]>(null as any);
    }

    updateSettings(command: SettingCommand): Promise<SettingsViewModel> {
        let url_ = this.baseUrl + "/api/Settings/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSettings(_response));
        });
    }

    protected processUpdateSettings(response: Response): Promise<SettingsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingsViewModel>(null as any);
    }
}

export class TagsCategoryClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTags(text: string | null | undefined, includeDeleted: boolean | undefined): Promise<TagCategoryDto[]> {
        let url_ = this.baseUrl + "/api/TagsCategory/GetTags?";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTags(_response));
        });
    }

    protected processGetTags(response: Response): Promise<TagCategoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = CommandError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagCategoryDto[]>(null as any);
    }

    addTag(command: TagCategoryCommanDto): Promise<AddOrUpdateTagCategoryResponse> {
        let url_ = this.baseUrl + "/api/TagsCategory/AddTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddTag(_response));
        });
    }

    protected processAddTag(response: Response): Promise<AddOrUpdateTagCategoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddOrUpdateTagCategoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = CommandError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddOrUpdateTagCategoryResponse>(null as any);
    }

    updateTag(id: string, command: TagCategoryCommanDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TagsCategory/UpdateTag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTag(_response));
        });
    }

    protected processUpdateTag(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    disableTag(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TagsCategory/DisableTag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisableTag(_response));
        });
    }

    protected processDisableTag(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = CommandError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TagsClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTags(text: string | null | undefined, includeDeleted: boolean | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<PagedResultOfReferentielTagViewModel> {
        let url_ = this.baseUrl + "/api/Tags/GetTags?";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTags(_response));
        });
    }

    protected processGetTags(response: Response): Promise<PagedResultOfReferentielTagViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfReferentielTagViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfReferentielTagViewModel>(null as any);
    }

    createTag(command: TagCommand): Promise<ReferentielTagViewModel> {
        let url_ = this.baseUrl + "/api/Tags/CreateTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateTag(_response));
        });
    }

    protected processCreateTag(response: Response): Promise<ReferentielTagViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferentielTagViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentielTagViewModel>(null as any);
    }

    updateTag(id: string | null, command: TagCommand): Promise<ReferentielTagViewModel> {
        let url_ = this.baseUrl + "/api/Tags/{id}/UpdateTag";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTag(_response));
        });
    }

    protected processUpdateTag(response: Response): Promise<ReferentielTagViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferentielTagViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentielTagViewModel>(null as any);
    }

    deleteTag(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Tags/{id}/DeleteTag";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTag(_response));
        });
    }

    protected processDeleteTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TaskClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTasks(text: string | null | undefined, includeDeleted: boolean | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<PagedResultOfReferentielTaskViewModel> {
        let url_ = this.baseUrl + "/api/Task/GetTasks?";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTasks(_response));
        });
    }

    protected processGetTasks(response: Response): Promise<PagedResultOfReferentielTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfReferentielTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfReferentielTaskViewModel>(null as any);
    }

    createTask(command: TaskCommand): Promise<ReferentielTaskViewModel> {
        let url_ = this.baseUrl + "/api/Task/CreateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateTask(_response));
        });
    }

    protected processCreateTask(response: Response): Promise<ReferentielTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferentielTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentielTaskViewModel>(null as any);
    }

    updateTask(id: string | null, command: TaskCommand): Promise<ReferentielTaskViewModel> {
        let url_ = this.baseUrl + "/api/Task/{id}/UpdateTask";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTask(_response));
        });
    }

    protected processUpdateTask(response: Response): Promise<ReferentielTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferentielTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentielTaskViewModel>(null as any);
    }

    deleteTask(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Task/{id}/DeleteTask";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTask(_response));
        });
    }

    protected processDeleteTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TemplateClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTimeSheets(key: string | null | undefined, outputMode: Mode | undefined, criteria: TimeSheetCriteria): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Template/GetTimeSheets?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (outputMode === null)
            throw new Error("The parameter 'outputMode' cannot be null.");
        else if (outputMode !== undefined)
            url_ += "outputMode=" + encodeURIComponent("" + outputMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTimeSheets(_response));
        });
    }

    protected processGetTimeSheets(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TiersClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getNextNumeroClient(): Promise<string> {
        let url_ = this.baseUrl + "/api/Tiers/GetNextNumeroClient";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNextNumeroClient(_response));
        });
    }

    protected processGetNextNumeroClient(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    list(text: string | null | undefined, includeDeleted: boolean | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<PagedResultOfClientViewModel> {
        let url_ = this.baseUrl + "/api/Tiers/List?";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<PagedResultOfClientViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfClientViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfClientViewModel>(null as any);
    }

    getById(clientId: string | null): Promise<ClientViewModel> {
        let url_ = this.baseUrl + "/api/Tiers/GetById/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ClientViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientViewModel>(null as any);
    }

    create(command: ClientCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tiers/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    update(id: string, command: ClientCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tiers/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    download(text: string | null | undefined, includeDeleted: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tiers/Download?";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tiers/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadClientExcelFile(formFile: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tiers/UploadClientExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadClientExcelFile(_response));
        });
    }

    protected processUploadClientExcelFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TimeClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTasksByTimeSheetId(request: GetTasksByTimeSheetIdRequestModel): Promise<ReadTimeSheetInputViewModel[]> {
        let url_ = this.baseUrl + "/api/Time/GetTasksByTimeSheetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTasksByTimeSheetId(_response));
        });
    }

    protected processGetTasksByTimeSheetId(response: Response): Promise<ReadTimeSheetInputViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReadTimeSheetInputViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadTimeSheetInputViewModel[]>(null as any);
    }

    getAbsencesByTimeSheetId(request: GetAbsencesByTimeSheetIdRequestModel): Promise<ReadAbsenceViewModel[]> {
        let url_ = this.baseUrl + "/api/Time/GetAbsencesByTimeSheetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAbsencesByTimeSheetId(_response));
        });
    }

    protected processGetAbsencesByTimeSheetId(response: Response): Promise<ReadAbsenceViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReadAbsenceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadAbsenceViewModel[]>(null as any);
    }

    getTasks(criteria: TimeSheetCriteria): Promise<ReadTimeSheetInputViewModel[]> {
        let url_ = this.baseUrl + "/api/Time/GetTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTasks(_response));
        });
    }

    protected processGetTasks(response: Response): Promise<ReadTimeSheetInputViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReadTimeSheetInputViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadTimeSheetInputViewModel[]>(null as any);
    }

    getAbsences(criteria: TimeSheetCriteria): Promise<ReadAbsenceViewModel[]> {
        let url_ = this.baseUrl + "/api/Time/GetAbsences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAbsences(_response));
        });
    }

    protected processGetAbsences(response: Response): Promise<ReadAbsenceViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReadAbsenceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadAbsenceViewModel[]>(null as any);
    }

    getTimeSheetById(id: string): Promise<GetTimeSheetDetailResponse> {
        let url_ = this.baseUrl + "/api/Time/getTimeSheetById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTimeSheetById(_response));
        });
    }

    protected processGetTimeSheetById(response: Response): Promise<GetTimeSheetDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTimeSheetDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTimeSheetDetailResponse>(null as any);
    }

    getTimeSheetSummary(userId: string | null | undefined, sheetAsk: Date | undefined): Promise<TimeSheetModel> {
        let url_ = this.baseUrl + "/api/Time/GetTimeSheetSummary?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (sheetAsk === null)
            throw new Error("The parameter 'sheetAsk' cannot be null.");
        else if (sheetAsk !== undefined)
            url_ += "sheetAsk=" + encodeURIComponent(sheetAsk ? "" + sheetAsk.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTimeSheetSummary(_response));
        });
    }

    protected processGetTimeSheetSummary(response: Response): Promise<TimeSheetModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeSheetModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeSheetModel>(null as any);
    }

    getTimeSheets(criteria: TimeSheetCriteria): Promise<ReadTimeSheetViewModel[]> {
        let url_ = this.baseUrl + "/api/Time/GetTimeSheets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTimeSheets(_response));
        });
    }

    protected processGetTimeSheets(response: Response): Promise<ReadTimeSheetViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReadTimeSheetViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadTimeSheetViewModel[]>(null as any);
    }

    addInputTime(command: InputTimeCommand): Promise<TimeSheetTaskInput> {
        let url_ = this.baseUrl + "/api/Time/AddInputTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddInputTime(_response));
        });
    }

    protected processAddInputTime(response: Response): Promise<TimeSheetTaskInput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeSheetTaskInput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeSheetTaskInput>(null as any);
    }

    addAbsenceTime(command: InputAbsence): Promise<TimeSheetAbsenceInput> {
        let url_ = this.baseUrl + "/api/Time/AddAbsenceTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddAbsenceTime(_response));
        });
    }

    protected processAddAbsenceTime(response: Response): Promise<TimeSheetAbsenceInput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeSheetAbsenceInput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeSheetAbsenceInput>(null as any);
    }

    addOrUpdateTimeSheet(command: DayTimeSheetCommand): Promise<TimeSheetTaskInput> {
        let url_ = this.baseUrl + "/api/Time/AddOrUpdateTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddOrUpdateTimeSheet(_response));
        });
    }

    protected processAddOrUpdateTimeSheet(response: Response): Promise<TimeSheetTaskInput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeSheetTaskInput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeSheetTaskInput>(null as any);
    }

    update(id: string, command: InputTimeCommand): Promise<TimeSheetTaskInput> {
        let url_ = this.baseUrl + "/api/Time/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<TimeSheetTaskInput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeSheetTaskInput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeSheetTaskInput>(null as any);
    }

    updateInputTimeComment(id: string, command: InputTimeCommentCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Time/UpdateInputTimeComment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateInputTimeComment(_response));
        });
    }

    protected processUpdateInputTimeComment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateAbsence(id: string, command: InputAbsence): Promise<TimeSheetAbsenceInput> {
        let url_ = this.baseUrl + "/api/Time/UpdateAbsence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAbsence(_response));
        });
    }

    protected processUpdateAbsence(response: Response): Promise<TimeSheetAbsenceInput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeSheetAbsenceInput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeSheetAbsenceInput>(null as any);
    }

    delete(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Time/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteAbsence(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Time/DeleteAbsence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAbsence(_response));
        });
    }

    protected processDeleteAbsence(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TypeAbsenceClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTypeAbsences(text: string | null | undefined, includeDeleted: boolean | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<PagedResultOfReferentielAbsenceViewModel> {
        let url_ = this.baseUrl + "/api/TypeAbsence/GetTypeAbsences?";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTypeAbsences(_response));
        });
    }

    protected processGetTypeAbsences(response: Response): Promise<PagedResultOfReferentielAbsenceViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfReferentielAbsenceViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfReferentielAbsenceViewModel>(null as any);
    }

    creerTypeAbsence(command: TypeAbsenceCommand): Promise<TypeAbsenceViewModel> {
        let url_ = this.baseUrl + "/api/TypeAbsence/CreerTypeAbsence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreerTypeAbsence(_response));
        });
    }

    protected processCreerTypeAbsence(response: Response): Promise<TypeAbsenceViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeAbsenceViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypeAbsenceViewModel>(null as any);
    }

    modifierTypeAbsence(id: string, command: TypeAbsenceCommand): Promise<TypeAbsenceViewModel> {
        let url_ = this.baseUrl + "/api/TypeAbsence/ModifierTypeAbsence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processModifierTypeAbsence(_response));
        });
    }

    protected processModifierTypeAbsence(response: Response): Promise<TypeAbsenceViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeAbsenceViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypeAbsenceViewModel>(null as any);
    }

    supprimerAbsence(id: string): Promise<string> {
        let url_ = this.baseUrl + "/api/TypeAbsence/SupprimerAbsence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSupprimerAbsence(_response));
        });
    }

    protected processSupprimerAbsence(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class UtilisateurClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: UserCommand): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/Utilisateur/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    download(role: string | null | undefined, minLevelRole: string | null | undefined, text: string | null | undefined, includeDeleted: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Utilisateur/Download?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        if (minLevelRole !== undefined && minLevelRole !== null)
            url_ += "minLevelRole=" + encodeURIComponent("" + minLevelRole) + "&";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    list(role: string | null | undefined, minLevelRole: string | null | undefined, text: string | null | undefined, includeDeleted: boolean | undefined, take: number | undefined, skip: number | undefined, orderBy: string | null | undefined, orderAsc: boolean | undefined): Promise<PagedResultOfUserViewModel> {
        let url_ = this.baseUrl + "/api/Utilisateur/list?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        if (minLevelRole !== undefined && minLevelRole !== null)
            url_ += "minLevelRole=" + encodeURIComponent("" + minLevelRole) + "&";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderAsc === null)
            throw new Error("The parameter 'orderAsc' cannot be null.");
        else if (orderAsc !== undefined)
            url_ += "OrderAsc=" + encodeURIComponent("" + orderAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<PagedResultOfUserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfUserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfUserViewModel>(null as any);
    }

    getById(userId: string): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/Utilisateur/GetById/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    update(id: string, command: UserCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Utilisateur/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    active(idQuery: string | undefined, idPath: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Utilisateur/Active/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActive(_response));
        });
    }

    protected processActive(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(idQuery: string | undefined, idPath: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Utilisateur/Delete/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ValidationClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getValidationsHistory(validationSheetId: string): Promise<ValidationViewModel[]> {
        let url_ = this.baseUrl + "/api/Validation/GetValidationsHistory/${validationSheetId}";
        if (validationSheetId === undefined || validationSheetId === null)
            throw new Error("The parameter 'validationSheetId' must be defined.");
        url_ = url_.replace("{validationSheetId}", encodeURIComponent("" + validationSheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetValidationsHistory(_response));
        });
    }

    protected processGetValidationsHistory(response: Response): Promise<ValidationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValidationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationViewModel[]>(null as any);
    }

    askTimeSheet(id: string): Promise<ValidSheetExpandViewModel> {
        let url_ = this.baseUrl + "/api/Validation/AskTimeSheet/${id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAskTimeSheet(_response));
        });
    }

    protected processAskTimeSheet(response: Response): Promise<ValidSheetExpandViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidSheetExpandViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidSheetExpandViewModel>(null as any);
    }

    askValidTimeSheet(criteria: ValidationListCommand): Promise<ValidTimeSheetViewModel[]> {
        let url_ = this.baseUrl + "/api/Validation/AskValidTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAskValidTimeSheet(_response));
        });
    }

    protected processAskValidTimeSheet(response: Response): Promise<ValidTimeSheetViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValidTimeSheetViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidTimeSheetViewModel[]>(null as any);
    }

    validateMyTimeSheet(command: UserValidationTimeSheetCommand): Promise<ValidTimeSheetViewModel> {
        let url_ = this.baseUrl + "/api/Validation/ValidateMyTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateMyTimeSheet(_response));
        });
    }

    protected processValidateMyTimeSheet(response: Response): Promise<ValidTimeSheetViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidTimeSheetViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidTimeSheetViewModel>(null as any);
    }

    timeSheet(command: ValidationByIdCommand): Promise<ValidationViewModel[]> {
        let url_ = this.baseUrl + "/api/Validation/TimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTimeSheet(_response));
        });
    }

    protected processTimeSheet(response: Response): Promise<ValidationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValidationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationViewModel[]>(null as any);
    }
}

export class AccountClientApi extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: any, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(model: LoginCommand): Promise<UserContext> {
        let url_ = this.baseUrl + "/api/Account/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogin(_response));
        });
    }

    protected processLogin(response: Response): Promise<UserContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContext.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 301) {
            return response.text().then((_responseText) => {
            let result301: any = null;
            let resultData301 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result301 = FirstConnexionResponse.fromJS(resultData301);
            return throwException("A server side error occurred.", status, _responseText, _headers, result301);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserContext>(null as any);
    }

    setSelectedEntreprise(id: string | null): Promise<UserContext> {
        let url_ = this.baseUrl + "/api/Account/SetSelectedEntreprise/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetSelectedEntreprise(_response));
        });
    }

    protected processSetSelectedEntreprise(response: Response): Promise<UserContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContext.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserContext>(null as any);
    }

    user(): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/Account/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUser(_response));
        });
    }

    protected processUser(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    createPassword(usertoken: string | null | undefined, model: CreatePasswordViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/CreatePassword?";
        if (usertoken !== undefined && usertoken !== null)
            url_ += "usertoken=" + encodeURIComponent("" + usertoken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePassword(_response));
        });
    }

    protected processCreatePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setPassword(userId: string | null, password: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/SetPassword/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(password);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetPassword(_response));
        });
    }

    protected processSetPassword(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    forgotPassword(email: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UpdatableDocument implements IUpdatableDocument {
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    deletedBy?: string | undefined;
    deletedOn?: Date | undefined;

    constructor(data?: IUpdatableDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatableDocument {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatableDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdatableDocument {
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    deletedBy?: string | undefined;
    deletedOn?: Date | undefined;
}

export class Cout extends UpdatableDocument implements ICout {
    id?: string;
    start?: Date;
    utilisateurId?: string;
    utilisateur?: Utilisateur | undefined;
    tauxHoraire?: number | undefined;

    constructor(data?: ICout) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.utilisateurId = _data["utilisateurId"];
            this.utilisateur = _data["utilisateur"] ? Utilisateur.fromJS(_data["utilisateur"]) : <any>undefined;
            this.tauxHoraire = _data["tauxHoraire"];
        }
    }

    static fromJS(data: any): Cout {
        data = typeof data === 'object' ? data : {};
        let result = new Cout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["utilisateurId"] = this.utilisateurId;
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        data["tauxHoraire"] = this.tauxHoraire;
        super.toJSON(data);
        return data;
    }
}

export interface ICout extends IUpdatableDocument {
    id?: string;
    start?: Date;
    utilisateurId?: string;
    utilisateur?: Utilisateur | undefined;
    tauxHoraire?: number | undefined;
}

export class Utilisateur extends UpdatableDocument implements IUtilisateur {
    idString?: string | undefined;
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    externalId?: string | undefined;
    histoCoutHoraire?: Cout[] | undefined;
    aspNetUserId?: string | undefined;
    responsables?: ResponsableUtilisateur[] | undefined;
    utilisateurs?: ResponsableUtilisateur[] | undefined;
    extendProperty?: ExtendProperty | undefined;
    baseSalaire?: number | undefined;
    accessAllChantier?: boolean;
    canAddTaskOnChantier?: boolean;
    saisieFeuilleTempsDisable?: boolean;
    tags?: UtilisateurTags[] | undefined;

    constructor(data?: IUtilisateur) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idString = _data["idString"];
            this.id = _data["id"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.email = _data["email"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["histoCoutHoraire"])) {
                this.histoCoutHoraire = [] as any;
                for (let item of _data["histoCoutHoraire"])
                    this.histoCoutHoraire!.push(Cout.fromJS(item));
            }
            this.aspNetUserId = _data["aspNetUserId"];
            if (Array.isArray(_data["responsables"])) {
                this.responsables = [] as any;
                for (let item of _data["responsables"])
                    this.responsables!.push(ResponsableUtilisateur.fromJS(item));
            }
            if (Array.isArray(_data["utilisateurs"])) {
                this.utilisateurs = [] as any;
                for (let item of _data["utilisateurs"])
                    this.utilisateurs!.push(ResponsableUtilisateur.fromJS(item));
            }
            this.extendProperty = _data["extendProperty"] ? ExtendProperty.fromJS(_data["extendProperty"]) : <any>undefined;
            this.baseSalaire = _data["baseSalaire"];
            this.accessAllChantier = _data["accessAllChantier"];
            this.canAddTaskOnChantier = _data["canAddTaskOnChantier"];
            this.saisieFeuilleTempsDisable = _data["saisieFeuilleTempsDisable"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(UtilisateurTags.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Utilisateur {
        data = typeof data === 'object' ? data : {};
        let result = new Utilisateur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idString"] = this.idString;
        data["id"] = this.id;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["email"] = this.email;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.histoCoutHoraire)) {
            data["histoCoutHoraire"] = [];
            for (let item of this.histoCoutHoraire)
                data["histoCoutHoraire"].push(item.toJSON());
        }
        data["aspNetUserId"] = this.aspNetUserId;
        if (Array.isArray(this.responsables)) {
            data["responsables"] = [];
            for (let item of this.responsables)
                data["responsables"].push(item.toJSON());
        }
        if (Array.isArray(this.utilisateurs)) {
            data["utilisateurs"] = [];
            for (let item of this.utilisateurs)
                data["utilisateurs"].push(item.toJSON());
        }
        data["extendProperty"] = this.extendProperty ? this.extendProperty.toJSON() : <any>undefined;
        data["baseSalaire"] = this.baseSalaire;
        data["accessAllChantier"] = this.accessAllChantier;
        data["canAddTaskOnChantier"] = this.canAddTaskOnChantier;
        data["saisieFeuilleTempsDisable"] = this.saisieFeuilleTempsDisable;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUtilisateur extends IUpdatableDocument {
    idString?: string | undefined;
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    externalId?: string | undefined;
    histoCoutHoraire?: Cout[] | undefined;
    aspNetUserId?: string | undefined;
    responsables?: ResponsableUtilisateur[] | undefined;
    utilisateurs?: ResponsableUtilisateur[] | undefined;
    extendProperty?: ExtendProperty | undefined;
    baseSalaire?: number | undefined;
    accessAllChantier?: boolean;
    canAddTaskOnChantier?: boolean;
    saisieFeuilleTempsDisable?: boolean;
    tags?: UtilisateurTags[] | undefined;
}

export class ResponsableUtilisateur implements IResponsableUtilisateur {
    utilisateur?: Utilisateur | undefined;
    utilisateurId?: string;
    responsableId?: string;
    responsable?: Utilisateur | undefined;

    constructor(data?: IResponsableUtilisateur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilisateur = _data["utilisateur"] ? Utilisateur.fromJS(_data["utilisateur"]) : <any>undefined;
            this.utilisateurId = _data["utilisateurId"];
            this.responsableId = _data["responsableId"];
            this.responsable = _data["responsable"] ? Utilisateur.fromJS(_data["responsable"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponsableUtilisateur {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsableUtilisateur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        data["utilisateurId"] = this.utilisateurId;
        data["responsableId"] = this.responsableId;
        data["responsable"] = this.responsable ? this.responsable.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponsableUtilisateur {
    utilisateur?: Utilisateur | undefined;
    utilisateurId?: string;
    responsableId?: string;
    responsable?: Utilisateur | undefined;
}

export class ExtendProperty implements IExtendProperty {
    key?: string | undefined;
    jsonValue?: string | undefined;

    constructor(data?: IExtendProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.jsonValue = _data["jsonValue"];
        }
    }

    static fromJS(data: any): ExtendProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["jsonValue"] = this.jsonValue;
        return data;
    }
}

export interface IExtendProperty {
    key?: string | undefined;
    jsonValue?: string | undefined;
}

export class UtilisateurTags implements IUtilisateurTags {
    tagCategoryId?: string;
    tagsCategory?: TagsCategoryModel | undefined;
    utilisateurId?: string;
    utilisateur?: Utilisateur | undefined;

    constructor(data?: IUtilisateurTags) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagCategoryId = _data["tagCategoryId"];
            this.tagsCategory = _data["tagsCategory"] ? TagsCategoryModel.fromJS(_data["tagsCategory"]) : <any>undefined;
            this.utilisateurId = _data["utilisateurId"];
            this.utilisateur = _data["utilisateur"] ? Utilisateur.fromJS(_data["utilisateur"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UtilisateurTags {
        data = typeof data === 'object' ? data : {};
        let result = new UtilisateurTags();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagCategoryId"] = this.tagCategoryId;
        data["tagsCategory"] = this.tagsCategory ? this.tagsCategory.toJSON() : <any>undefined;
        data["utilisateurId"] = this.utilisateurId;
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUtilisateurTags {
    tagCategoryId?: string;
    tagsCategory?: TagsCategoryModel | undefined;
    utilisateurId?: string;
    utilisateur?: Utilisateur | undefined;
}

export class TagsCategoryModel extends UpdatableDocument implements ITagsCategoryModel {
    id?: string;
    categoryName?: string | undefined;
    utilisateurs?: UtilisateurTags[] | undefined;
    tasks?: ReferentielTags[] | undefined;
    taskProjects?: TaskProjectsTags[] | undefined;

    constructor(data?: ITagsCategoryModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.categoryName = _data["categoryName"];
            if (Array.isArray(_data["utilisateurs"])) {
                this.utilisateurs = [] as any;
                for (let item of _data["utilisateurs"])
                    this.utilisateurs!.push(UtilisateurTags.fromJS(item));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ReferentielTags.fromJS(item));
            }
            if (Array.isArray(_data["taskProjects"])) {
                this.taskProjects = [] as any;
                for (let item of _data["taskProjects"])
                    this.taskProjects!.push(TaskProjectsTags.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagsCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagsCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryName"] = this.categoryName;
        if (Array.isArray(this.utilisateurs)) {
            data["utilisateurs"] = [];
            for (let item of this.utilisateurs)
                data["utilisateurs"].push(item.toJSON());
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        if (Array.isArray(this.taskProjects)) {
            data["taskProjects"] = [];
            for (let item of this.taskProjects)
                data["taskProjects"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITagsCategoryModel extends IUpdatableDocument {
    id?: string;
    categoryName?: string | undefined;
    utilisateurs?: UtilisateurTags[] | undefined;
    tasks?: ReferentielTags[] | undefined;
    taskProjects?: TaskProjectsTags[] | undefined;
}

export class ReferentielTags implements IReferentielTags {
    tagCategoryId?: string;
    tagsCategory?: TagsCategoryModel | undefined;
    referentielTaskId?: string;
    referentielTask?: ReferentielTask | undefined;

    constructor(data?: IReferentielTags) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagCategoryId = _data["tagCategoryId"];
            this.tagsCategory = _data["tagsCategory"] ? TagsCategoryModel.fromJS(_data["tagsCategory"]) : <any>undefined;
            this.referentielTaskId = _data["referentielTaskId"];
            this.referentielTask = _data["referentielTask"] ? ReferentielTask.fromJS(_data["referentielTask"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReferentielTags {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentielTags();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagCategoryId"] = this.tagCategoryId;
        data["tagsCategory"] = this.tagsCategory ? this.tagsCategory.toJSON() : <any>undefined;
        data["referentielTaskId"] = this.referentielTaskId;
        data["referentielTask"] = this.referentielTask ? this.referentielTask.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReferentielTags {
    tagCategoryId?: string;
    tagsCategory?: TagsCategoryModel | undefined;
    referentielTaskId?: string;
    referentielTask?: ReferentielTask | undefined;
}

export class ReferentielTask extends UpdatableDocument implements IReferentielTask {
    id?: string;
    label?: string | undefined;
    taskCode?: string | undefined;
    description?: string | undefined;
    addOnProjectCreated?: boolean;
    tags?: ReferentielTags[] | undefined;

    constructor(data?: IReferentielTask) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.taskCode = _data["taskCode"];
            this.description = _data["description"];
            this.addOnProjectCreated = _data["addOnProjectCreated"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ReferentielTags.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReferentielTask {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentielTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["taskCode"] = this.taskCode;
        data["description"] = this.description;
        data["addOnProjectCreated"] = this.addOnProjectCreated;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IReferentielTask extends IUpdatableDocument {
    id?: string;
    label?: string | undefined;
    taskCode?: string | undefined;
    description?: string | undefined;
    addOnProjectCreated?: boolean;
    tags?: ReferentielTags[] | undefined;
}

export class TaskProjectsTags implements ITaskProjectsTags {
    tagCategoryId?: string;
    tagsCategory?: TagsCategoryModel | undefined;
    taskProjectId?: string;
    taskProject?: TaskProject | undefined;

    constructor(data?: ITaskProjectsTags) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagCategoryId = _data["tagCategoryId"];
            this.tagsCategory = _data["tagsCategory"] ? TagsCategoryModel.fromJS(_data["tagsCategory"]) : <any>undefined;
            this.taskProjectId = _data["taskProjectId"];
            this.taskProject = _data["taskProject"] ? TaskProject.fromJS(_data["taskProject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskProjectsTags {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProjectsTags();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagCategoryId"] = this.tagCategoryId;
        data["tagsCategory"] = this.tagsCategory ? this.tagsCategory.toJSON() : <any>undefined;
        data["taskProjectId"] = this.taskProjectId;
        data["taskProject"] = this.taskProject ? this.taskProject.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskProjectsTags {
    tagCategoryId?: string;
    tagsCategory?: TagsCategoryModel | undefined;
    taskProjectId?: string;
    taskProject?: TaskProject | undefined;
}

export class TaskProject implements ITaskProject {
    id?: string;
    taskProjectLabel?: string | undefined;
    taskCode?: string | undefined;
    projectId?: string | undefined;
    project?: Project | undefined;
    taskRefId?: string | undefined;
    taskRef?: ReferentielTask | undefined;
    statusTask?: StatusTask;
    timePlanned?: number | undefined;
    timeSheetInputs?: TimeSheetTaskInput[] | undefined;
    tags?: TaskProjectsTags[] | undefined;

    constructor(data?: ITaskProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskProjectLabel = _data["taskProjectLabel"];
            this.taskCode = _data["taskCode"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.taskRefId = _data["taskRefId"];
            this.taskRef = _data["taskRef"] ? ReferentielTask.fromJS(_data["taskRef"]) : <any>undefined;
            this.statusTask = _data["statusTask"];
            this.timePlanned = _data["timePlanned"];
            if (Array.isArray(_data["timeSheetInputs"])) {
                this.timeSheetInputs = [] as any;
                for (let item of _data["timeSheetInputs"])
                    this.timeSheetInputs!.push(TimeSheetTaskInput.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TaskProjectsTags.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskProject {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskProjectLabel"] = this.taskProjectLabel;
        data["taskCode"] = this.taskCode;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["taskRefId"] = this.taskRefId;
        data["taskRef"] = this.taskRef ? this.taskRef.toJSON() : <any>undefined;
        data["statusTask"] = this.statusTask;
        data["timePlanned"] = this.timePlanned;
        if (Array.isArray(this.timeSheetInputs)) {
            data["timeSheetInputs"] = [];
            for (let item of this.timeSheetInputs)
                data["timeSheetInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskProject {
    id?: string;
    taskProjectLabel?: string | undefined;
    taskCode?: string | undefined;
    projectId?: string | undefined;
    project?: Project | undefined;
    taskRefId?: string | undefined;
    taskRef?: ReferentielTask | undefined;
    statusTask?: StatusTask;
    timePlanned?: number | undefined;
    timeSheetInputs?: TimeSheetTaskInput[] | undefined;
    tags?: TaskProjectsTags[] | undefined;
}

export class Project extends UpdatableDocument implements IProject {
    id?: string;
    label?: string | undefined;
    externalId?: string | undefined;
    clientId?: string | undefined;
    client?: Client | undefined;
    projectStatus?: ProjectStatus;
    isBillable?: boolean;
    estimatedEndDate?: Date | undefined;
    estimatedStartDate?: Date | undefined;
    amount?: number | undefined;
    documents?: Document[] | undefined;
    tasks?: TaskProject[] | undefined;
    responsables?: ResponsableProjet[] | undefined;
    commerciaux?: CommercialProjet[] | undefined;
    ouverteALaSaisie?: Date | undefined;
    tags?: TagsProject[] | undefined;
    commentaire?: string | undefined;
    adresseProjetId?: string | undefined;
    adresseProjet?: AdresseProjet | undefined;

    constructor(data?: IProject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.externalId = _data["externalId"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.projectStatus = _data["projectStatus"];
            this.isBillable = _data["isBillable"];
            this.estimatedEndDate = _data["estimatedEndDate"] ? new Date(_data["estimatedEndDate"].toString()) : <any>undefined;
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskProject.fromJS(item));
            }
            if (Array.isArray(_data["responsables"])) {
                this.responsables = [] as any;
                for (let item of _data["responsables"])
                    this.responsables!.push(ResponsableProjet.fromJS(item));
            }
            if (Array.isArray(_data["commerciaux"])) {
                this.commerciaux = [] as any;
                for (let item of _data["commerciaux"])
                    this.commerciaux!.push(CommercialProjet.fromJS(item));
            }
            this.ouverteALaSaisie = _data["ouverteALaSaisie"] ? new Date(_data["ouverteALaSaisie"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagsProject.fromJS(item));
            }
            this.commentaire = _data["commentaire"];
            this.adresseProjetId = _data["adresseProjetId"];
            this.adresseProjet = _data["adresseProjet"] ? AdresseProjet.fromJS(_data["adresseProjet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["externalId"] = this.externalId;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["projectStatus"] = this.projectStatus;
        data["isBillable"] = this.isBillable;
        data["estimatedEndDate"] = this.estimatedEndDate ? this.estimatedEndDate.toISOString() : <any>undefined;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        if (Array.isArray(this.responsables)) {
            data["responsables"] = [];
            for (let item of this.responsables)
                data["responsables"].push(item.toJSON());
        }
        if (Array.isArray(this.commerciaux)) {
            data["commerciaux"] = [];
            for (let item of this.commerciaux)
                data["commerciaux"].push(item.toJSON());
        }
        data["ouverteALaSaisie"] = this.ouverteALaSaisie ? this.ouverteALaSaisie.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["commentaire"] = this.commentaire;
        data["adresseProjetId"] = this.adresseProjetId;
        data["adresseProjet"] = this.adresseProjet ? this.adresseProjet.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProject extends IUpdatableDocument {
    id?: string;
    label?: string | undefined;
    externalId?: string | undefined;
    clientId?: string | undefined;
    client?: Client | undefined;
    projectStatus?: ProjectStatus;
    isBillable?: boolean;
    estimatedEndDate?: Date | undefined;
    estimatedStartDate?: Date | undefined;
    amount?: number | undefined;
    documents?: Document[] | undefined;
    tasks?: TaskProject[] | undefined;
    responsables?: ResponsableProjet[] | undefined;
    commerciaux?: CommercialProjet[] | undefined;
    ouverteALaSaisie?: Date | undefined;
    tags?: TagsProject[] | undefined;
    commentaire?: string | undefined;
    adresseProjetId?: string | undefined;
    adresseProjet?: AdresseProjet | undefined;
}

export class Client extends UpdatableDocument implements IClient {
    id?: string;
    name?: string | undefined;
    firstname?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IClient) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        data["externalId"] = this.externalId;
        super.toJSON(data);
        return data;
    }
}

export interface IClient extends IUpdatableDocument {
    id?: string;
    name?: string | undefined;
    firstname?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    externalId?: string | undefined;
}

export enum ProjectStatus {
    CREATE = 1,
    PROGRESS = 2,
    CLOSE = 3,
    PAUSE = 50,
}

export class Document implements IDocument {
    id?: string;
    projectId?: string | undefined;
    url?: string | undefined;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["url"] = this.url;
        return data;
    }
}

export interface IDocument {
    id?: string;
    projectId?: string | undefined;
    url?: string | undefined;
}

export class ResponsableProjet implements IResponsableProjet {
    projectId?: string;
    project?: Project | undefined;
    responsableId?: string;
    responsable?: Utilisateur | undefined;

    constructor(data?: IResponsableProjet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.responsableId = _data["responsableId"];
            this.responsable = _data["responsable"] ? Utilisateur.fromJS(_data["responsable"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponsableProjet {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsableProjet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["responsableId"] = this.responsableId;
        data["responsable"] = this.responsable ? this.responsable.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponsableProjet {
    projectId?: string;
    project?: Project | undefined;
    responsableId?: string;
    responsable?: Utilisateur | undefined;
}

export class CommercialProjet implements ICommercialProjet {
    projectId?: string;
    project?: Project | undefined;
    commercialId?: string;
    commercial?: Utilisateur | undefined;

    constructor(data?: ICommercialProjet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.commercialId = _data["commercialId"];
            this.commercial = _data["commercial"] ? Utilisateur.fromJS(_data["commercial"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommercialProjet {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialProjet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["commercialId"] = this.commercialId;
        data["commercial"] = this.commercial ? this.commercial.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommercialProjet {
    projectId?: string;
    project?: Project | undefined;
    commercialId?: string;
    commercial?: Utilisateur | undefined;
}

export class TagsProject implements ITagsProject {
    id?: string;
    projectId?: string;
    project?: Project | undefined;
    tagId?: string;
    tag?: Tag | undefined;

    constructor(data?: ITagsProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TagsProject {
        data = typeof data === 'object' ? data : {};
        let result = new TagsProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITagsProject {
    id?: string;
    projectId?: string;
    project?: Project | undefined;
    tagId?: string;
    tag?: Tag | undefined;
}

export class Tag implements ITag {
    id?: string;
    label?: string | undefined;
    color?: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["color"] = this.color;
        return data;
    }
}

export interface ITag {
    id?: string;
    label?: string | undefined;
    color?: string | undefined;
}

export abstract class BaseAdresse implements IBaseAdresse {
    id?: string;
    adresse?: string | undefined;
    cp?: string | undefined;
    ville?: string | undefined;
    lat?: number | undefined;
    lng?: number | undefined;

    constructor(data?: IBaseAdresse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.adresse = _data["adresse"];
            this.cp = _data["cp"];
            this.ville = _data["ville"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): BaseAdresse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseAdresse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["adresse"] = this.adresse;
        data["cp"] = this.cp;
        data["ville"] = this.ville;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }
}

export interface IBaseAdresse {
    id?: string;
    adresse?: string | undefined;
    cp?: string | undefined;
    ville?: string | undefined;
    lat?: number | undefined;
    lng?: number | undefined;
}

export class AdresseProjet extends BaseAdresse implements IAdresseProjet {
    projectId?: string;
    project?: Project | undefined;

    constructor(data?: IAdresseProjet) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdresseProjet {
        data = typeof data === 'object' ? data : {};
        let result = new AdresseProjet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAdresseProjet extends IBaseAdresse {
    projectId?: string;
    project?: Project | undefined;
}

export enum StatusTask {
    NOT_OPENED = 1,
    OPENED = 2,
    FINISHED = 3,
}

export abstract class TimeSheetInputBase extends UpdatableDocument implements ITimeSheetInputBase {
    id?: string;
    timeSheetId?: string;
    timeSheet?: TimeSheet | undefined;
    time?: number;
    comment?: string | undefined;

    constructor(data?: ITimeSheetInputBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.timeSheetId = _data["timeSheetId"];
            this.timeSheet = _data["timeSheet"] ? TimeSheet.fromJS(_data["timeSheet"]) : <any>undefined;
            this.time = _data["time"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): TimeSheetInputBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TimeSheetInputBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeSheetId"] = this.timeSheetId;
        data["timeSheet"] = this.timeSheet ? this.timeSheet.toJSON() : <any>undefined;
        data["time"] = this.time;
        data["comment"] = this.comment;
        super.toJSON(data);
        return data;
    }
}

export interface ITimeSheetInputBase extends IUpdatableDocument {
    id?: string;
    timeSheetId?: string;
    timeSheet?: TimeSheet | undefined;
    time?: number;
    comment?: string | undefined;
}

export class TimeSheetTaskInput extends TimeSheetInputBase implements ITimeSheetTaskInput {
    taskProject?: TaskProject | undefined;
    taskProjectId?: string | undefined;
    isFinished?: boolean;
    heuresDeNuit?: boolean;

    constructor(data?: ITimeSheetTaskInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskProject = _data["taskProject"] ? TaskProject.fromJS(_data["taskProject"]) : <any>undefined;
            this.taskProjectId = _data["taskProjectId"];
            this.isFinished = _data["isFinished"];
            this.heuresDeNuit = _data["heuresDeNuit"];
        }
    }

    static fromJS(data: any): TimeSheetTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskProject"] = this.taskProject ? this.taskProject.toJSON() : <any>undefined;
        data["taskProjectId"] = this.taskProjectId;
        data["isFinished"] = this.isFinished;
        data["heuresDeNuit"] = this.heuresDeNuit;
        super.toJSON(data);
        return data;
    }
}

export interface ITimeSheetTaskInput extends ITimeSheetInputBase {
    taskProject?: TaskProject | undefined;
    taskProjectId?: string | undefined;
    isFinished?: boolean;
    heuresDeNuit?: boolean;
}

export class TimeSheet extends UpdatableDocument implements ITimeSheet {
    prime?: number | undefined;
    id?: string;
    sheetDate?: Date;
    timeSheetStatus?: TimeSheetStatus;
    timeSheetTasksInputs?: TimeSheetInputBase[] | undefined;
    validTimeSheetId?: string | undefined;
    validTimeSheet?: ValidTimeSheet | undefined;
    utilisateurId?: string;
    utilisateur?: Utilisateur | undefined;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    coutJournalier?: number | undefined;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
    numeroSemaine?: number;

    constructor(data?: ITimeSheet) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.prime = _data["prime"];
            this.id = _data["id"];
            this.sheetDate = _data["sheetDate"] ? new Date(_data["sheetDate"].toString()) : <any>undefined;
            this.timeSheetStatus = _data["timeSheetStatus"];
            if (Array.isArray(_data["timeSheetTasksInputs"])) {
                this.timeSheetTasksInputs = [] as any;
                for (let item of _data["timeSheetTasksInputs"])
                    this.timeSheetTasksInputs!.push(TimeSheetInputBase.fromJS(item));
            }
            this.validTimeSheetId = _data["validTimeSheetId"];
            this.validTimeSheet = _data["validTimeSheet"] ? ValidTimeSheet.fromJS(_data["validTimeSheet"]) : <any>undefined;
            this.utilisateurId = _data["utilisateurId"];
            this.utilisateur = _data["utilisateur"] ? Utilisateur.fromJS(_data["utilisateur"]) : <any>undefined;
            this.panierRepas = _data["panierRepas"];
            this.grandDeplacement = _data["grandDeplacement"];
            this.coutJournalier = _data["coutJournalier"];
            this.tempsTrajet = _data["tempsTrajet"];
            this.tempsTrajetSurHeureTravaillees = _data["tempsTrajetSurHeureTravaillees"];
            this.kmPro = _data["kmPro"];
            this.kmPerso = _data["kmPerso"];
            this.kmPersoJustification = _data["kmPersoJustification"];
            this.numeroSemaine = _data["numeroSemaine"];
        }
    }

    static fromJS(data: any): TimeSheet {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prime"] = this.prime;
        data["id"] = this.id;
        data["sheetDate"] = this.sheetDate ? this.sheetDate.toISOString() : <any>undefined;
        data["timeSheetStatus"] = this.timeSheetStatus;
        if (Array.isArray(this.timeSheetTasksInputs)) {
            data["timeSheetTasksInputs"] = [];
            for (let item of this.timeSheetTasksInputs)
                data["timeSheetTasksInputs"].push(item.toJSON());
        }
        data["validTimeSheetId"] = this.validTimeSheetId;
        data["validTimeSheet"] = this.validTimeSheet ? this.validTimeSheet.toJSON() : <any>undefined;
        data["utilisateurId"] = this.utilisateurId;
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        data["panierRepas"] = this.panierRepas;
        data["grandDeplacement"] = this.grandDeplacement;
        data["coutJournalier"] = this.coutJournalier;
        data["tempsTrajet"] = this.tempsTrajet;
        data["tempsTrajetSurHeureTravaillees"] = this.tempsTrajetSurHeureTravaillees;
        data["kmPro"] = this.kmPro;
        data["kmPerso"] = this.kmPerso;
        data["kmPersoJustification"] = this.kmPersoJustification;
        data["numeroSemaine"] = this.numeroSemaine;
        super.toJSON(data);
        return data;
    }
}

export interface ITimeSheet extends IUpdatableDocument {
    prime?: number | undefined;
    id?: string;
    sheetDate?: Date;
    timeSheetStatus?: TimeSheetStatus;
    timeSheetTasksInputs?: TimeSheetInputBase[] | undefined;
    validTimeSheetId?: string | undefined;
    validTimeSheet?: ValidTimeSheet | undefined;
    utilisateurId?: string;
    utilisateur?: Utilisateur | undefined;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    coutJournalier?: number | undefined;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
    numeroSemaine?: number;
}

export enum TimeSheetStatus {
    OPENED = 0,
    TO_BE_VALIDATE = 1,
    VALIDATED = 2,
}

export class ValidTimeSheet extends UpdatableDocument implements IValidTimeSheet {
    id?: string;
    numSemaine?: number;
    utilisateurTimeSheetId?: string;
    utilisateurTimeSheet?: Utilisateur | undefined;
    startDate?: Date;
    usersValidation?: Validation[] | undefined;
    timeSheets?: TimeSheet[] | undefined;

    constructor(data?: IValidTimeSheet) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.numSemaine = _data["numSemaine"];
            this.utilisateurTimeSheetId = _data["utilisateurTimeSheetId"];
            this.utilisateurTimeSheet = _data["utilisateurTimeSheet"] ? Utilisateur.fromJS(_data["utilisateurTimeSheet"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["usersValidation"])) {
                this.usersValidation = [] as any;
                for (let item of _data["usersValidation"])
                    this.usersValidation!.push(Validation.fromJS(item));
            }
            if (Array.isArray(_data["timeSheets"])) {
                this.timeSheets = [] as any;
                for (let item of _data["timeSheets"])
                    this.timeSheets!.push(TimeSheet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidTimeSheet {
        data = typeof data === 'object' ? data : {};
        let result = new ValidTimeSheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numSemaine"] = this.numSemaine;
        data["utilisateurTimeSheetId"] = this.utilisateurTimeSheetId;
        data["utilisateurTimeSheet"] = this.utilisateurTimeSheet ? this.utilisateurTimeSheet.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        if (Array.isArray(this.usersValidation)) {
            data["usersValidation"] = [];
            for (let item of this.usersValidation)
                data["usersValidation"].push(item.toJSON());
        }
        if (Array.isArray(this.timeSheets)) {
            data["timeSheets"] = [];
            for (let item of this.timeSheets)
                data["timeSheets"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidTimeSheet extends IUpdatableDocument {
    id?: string;
    numSemaine?: number;
    utilisateurTimeSheetId?: string;
    utilisateurTimeSheet?: Utilisateur | undefined;
    startDate?: Date;
    usersValidation?: Validation[] | undefined;
    timeSheets?: TimeSheet[] | undefined;
}

export class Validation implements IValidation {
    id?: string;
    validTimeSheetId?: string;
    validTimeSheet?: ValidTimeSheet | undefined;
    validationLevel?: ValidationLevel;
    validationUserId?: string | undefined;
    validationUtilisateur?: Utilisateur | undefined;
    askValidationDate?: Date | undefined;
    responseDate?: Date | undefined;
    validationStatus?: ValidationStatus;
    forceValidationUserId?: string | undefined;
    forceValidationUser?: Utilisateur | undefined;
    commentaire?: string | undefined;

    constructor(data?: IValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validTimeSheetId = _data["validTimeSheetId"];
            this.validTimeSheet = _data["validTimeSheet"] ? ValidTimeSheet.fromJS(_data["validTimeSheet"]) : <any>undefined;
            this.validationLevel = _data["validationLevel"];
            this.validationUserId = _data["validationUserId"];
            this.validationUtilisateur = _data["validationUtilisateur"] ? Utilisateur.fromJS(_data["validationUtilisateur"]) : <any>undefined;
            this.askValidationDate = _data["askValidationDate"] ? new Date(_data["askValidationDate"].toString()) : <any>undefined;
            this.responseDate = _data["responseDate"] ? new Date(_data["responseDate"].toString()) : <any>undefined;
            this.validationStatus = _data["validationStatus"];
            this.forceValidationUserId = _data["forceValidationUserId"];
            this.forceValidationUser = _data["forceValidationUser"] ? Utilisateur.fromJS(_data["forceValidationUser"]) : <any>undefined;
            this.commentaire = _data["commentaire"];
        }
    }

    static fromJS(data: any): Validation {
        data = typeof data === 'object' ? data : {};
        let result = new Validation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validTimeSheetId"] = this.validTimeSheetId;
        data["validTimeSheet"] = this.validTimeSheet ? this.validTimeSheet.toJSON() : <any>undefined;
        data["validationLevel"] = this.validationLevel;
        data["validationUserId"] = this.validationUserId;
        data["validationUtilisateur"] = this.validationUtilisateur ? this.validationUtilisateur.toJSON() : <any>undefined;
        data["askValidationDate"] = this.askValidationDate ? this.askValidationDate.toISOString() : <any>undefined;
        data["responseDate"] = this.responseDate ? this.responseDate.toISOString() : <any>undefined;
        data["validationStatus"] = this.validationStatus;
        data["forceValidationUserId"] = this.forceValidationUserId;
        data["forceValidationUser"] = this.forceValidationUser ? this.forceValidationUser.toJSON() : <any>undefined;
        data["commentaire"] = this.commentaire;
        return data;
    }
}

export interface IValidation {
    id?: string;
    validTimeSheetId?: string;
    validTimeSheet?: ValidTimeSheet | undefined;
    validationLevel?: ValidationLevel;
    validationUserId?: string | undefined;
    validationUtilisateur?: Utilisateur | undefined;
    askValidationDate?: Date | undefined;
    responseDate?: Date | undefined;
    validationStatus?: ValidationStatus;
    forceValidationUserId?: string | undefined;
    forceValidationUser?: Utilisateur | undefined;
    commentaire?: string | undefined;
}

export enum ValidationLevel {
    USER = 0,
    RESPONSABLE = 1,
    COMMERCIAL = 2,
    ENTREPRISE = 3,
}

export enum ValidationStatus {
    ASK = 0,
    VALIDATED = 1,
    REFUSED = 2,
    ACCEPT_BY_SUPERIOR = 3,
    REFUSE_BY_SUPERIOR = 4,
}

export class CommandError implements ICommandError {
    errors?: CommandErrorDetail[] | undefined;

    constructor(data?: ICommandError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(CommandErrorDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommandError {
        data = typeof data === 'object' ? data : {};
        let result = new CommandError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommandError {
    errors?: CommandErrorDetail[] | undefined;
}

export class CommandErrorDetail implements ICommandErrorDetail {
    errorCode?: ValidationErrorCode;
    errorMessage?: string | undefined;
    propertyName?: string | undefined;

    constructor(data?: ICommandErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.propertyName = _data["propertyName"];
        }
    }

    static fromJS(data: any): CommandErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CommandErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["propertyName"] = this.propertyName;
        return data;
    }
}

export interface ICommandErrorDetail {
    errorCode?: ValidationErrorCode;
    errorMessage?: string | undefined;
    propertyName?: string | undefined;
}

export enum ValidationErrorCode {
    UnexpectedError = 0,
    ArgumentException = 1,
    CommandFailed = 2,
    UnAuthorizedAccess = 3,
}

export class CoutHoraireCommand implements ICoutHoraireCommand {
    start?: Date;
    utilisateurId?: string;
    tauxHoraire?: number | undefined;

    constructor(data?: ICoutHoraireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.utilisateurId = _data["utilisateurId"];
            this.tauxHoraire = _data["tauxHoraire"];
        }
    }

    static fromJS(data: any): CoutHoraireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CoutHoraireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["utilisateurId"] = this.utilisateurId;
        data["tauxHoraire"] = this.tauxHoraire;
        return data;
    }
}

export interface ICoutHoraireCommand {
    start?: Date;
    utilisateurId?: string;
    tauxHoraire?: number | undefined;
}

export class CoutHoraireViewModel implements ICoutHoraireViewModel {
    id?: string;
    start?: Date;
    utilisateurId?: string;
    utilisateur?: Utilisateur | undefined;
    tauxHoraire?: number | undefined;
    isDeleted?: boolean;
    isActive?: boolean;

    constructor(data?: ICoutHoraireViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.utilisateurId = _data["utilisateurId"];
            this.utilisateur = _data["utilisateur"] ? Utilisateur.fromJS(_data["utilisateur"]) : <any>undefined;
            this.tauxHoraire = _data["tauxHoraire"];
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CoutHoraireViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoutHoraireViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["utilisateurId"] = this.utilisateurId;
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        data["tauxHoraire"] = this.tauxHoraire;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICoutHoraireViewModel {
    id?: string;
    start?: Date;
    utilisateurId?: string;
    utilisateur?: Utilisateur | undefined;
    tauxHoraire?: number | undefined;
    isDeleted?: boolean;
    isActive?: boolean;
}

export class GetResumeNeedValidateResponseModel implements IGetResumeNeedValidateResponseModel {
    timeSheetResponses?: TimeSheetResponseModel[] | undefined;

    constructor(data?: IGetResumeNeedValidateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timeSheetResponses"])) {
                this.timeSheetResponses = [] as any;
                for (let item of _data["timeSheetResponses"])
                    this.timeSheetResponses!.push(TimeSheetResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetResumeNeedValidateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetResumeNeedValidateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timeSheetResponses)) {
            data["timeSheetResponses"] = [];
            for (let item of this.timeSheetResponses)
                data["timeSheetResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetResumeNeedValidateResponseModel {
    timeSheetResponses?: TimeSheetResponseModel[] | undefined;
}

export class TimeSheetResponseModel implements ITimeSheetResponseModel {
    validationId?: string;
    numSemaine?: number;
    utilisateur?: UtilisateurResponseModel | undefined;
    startDate?: Date;

    constructor(data?: ITimeSheetResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationId = _data["validationId"];
            this.numSemaine = _data["numSemaine"];
            this.utilisateur = _data["utilisateur"] ? UtilisateurResponseModel.fromJS(_data["utilisateur"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeSheetResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationId"] = this.validationId;
        data["numSemaine"] = this.numSemaine;
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITimeSheetResponseModel {
    validationId?: string;
    numSemaine?: number;
    utilisateur?: UtilisateurResponseModel | undefined;
    startDate?: Date;
}

export class UtilisateurResponseModel implements IUtilisateurResponseModel {
    utilisateurId?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    role?: string | undefined;

    constructor(data?: IUtilisateurResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilisateurId = _data["utilisateurId"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UtilisateurResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UtilisateurResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilisateurId"] = this.utilisateurId;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["role"] = this.role;
        return data;
    }
}

export interface IUtilisateurResponseModel {
    utilisateurId?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    role?: string | undefined;
}

export class GetRefuseTimeSheetResponseModel implements IGetRefuseTimeSheetResponseModel {
    timeSheetValidationResponseModel?: TimeSheetValidationResponseModel | undefined;

    constructor(data?: IGetRefuseTimeSheetResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSheetValidationResponseModel = _data["timeSheetValidationResponseModel"] ? TimeSheetValidationResponseModel.fromJS(_data["timeSheetValidationResponseModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRefuseTimeSheetResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetRefuseTimeSheetResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSheetValidationResponseModel"] = this.timeSheetValidationResponseModel ? this.timeSheetValidationResponseModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRefuseTimeSheetResponseModel {
    timeSheetValidationResponseModel?: TimeSheetValidationResponseModel | undefined;
}

export class TimeSheetValidationResponseModel implements ITimeSheetValidationResponseModel {
    validationId?: string;
    numSemaine?: string | undefined;
    dateDebutSemaine?: Date;
    validation?: ValidationModel | undefined;

    constructor(data?: ITimeSheetValidationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationId = _data["validationId"];
            this.numSemaine = _data["numSemaine"];
            this.dateDebutSemaine = _data["dateDebutSemaine"] ? new Date(_data["dateDebutSemaine"].toString()) : <any>undefined;
            this.validation = _data["validation"] ? ValidationModel.fromJS(_data["validation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeSheetValidationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetValidationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationId"] = this.validationId;
        data["numSemaine"] = this.numSemaine;
        data["dateDebutSemaine"] = this.dateDebutSemaine ? this.dateDebutSemaine.toISOString() : <any>undefined;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeSheetValidationResponseModel {
    validationId?: string;
    numSemaine?: string | undefined;
    dateDebutSemaine?: Date;
    validation?: ValidationModel | undefined;
}

export class ValidationModel implements IValidationModel {
    validationLevel?: ValidationLevel;
    validationStatus?: ValidationStatus;
    responseDate?: Date | undefined;
    commentaire?: string | undefined;
    utilisateur?: UtilisateurResponseModel | undefined;

    constructor(data?: IValidationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationLevel = _data["validationLevel"];
            this.validationStatus = _data["validationStatus"];
            this.responseDate = _data["responseDate"] ? new Date(_data["responseDate"].toString()) : <any>undefined;
            this.commentaire = _data["commentaire"];
            this.utilisateur = _data["utilisateur"] ? UtilisateurResponseModel.fromJS(_data["utilisateur"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationLevel"] = this.validationLevel;
        data["validationStatus"] = this.validationStatus;
        data["responseDate"] = this.responseDate ? this.responseDate.toISOString() : <any>undefined;
        data["commentaire"] = this.commentaire;
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidationModel {
    validationLevel?: ValidationLevel;
    validationStatus?: ValidationStatus;
    responseDate?: Date | undefined;
    commentaire?: string | undefined;
    utilisateur?: UtilisateurResponseModel | undefined;
}

export class ExportTableDefinitionResponse implements IExportTableDefinitionResponse {
    columns?: ExportTableColumnDefinition[] | undefined;

    constructor(data?: IExportTableDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ExportTableColumnDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportTableDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTableDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportTableDefinitionResponse {
    columns?: ExportTableColumnDefinition[] | undefined;
}

export class ExportTableColumnDefinition implements IExportTableColumnDefinition {
    key?: string | undefined;
    label?: string | undefined;
    isExport?: boolean;
    sortable?: boolean;

    constructor(data?: IExportTableColumnDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.isExport = _data["isExport"];
            this.sortable = _data["sortable"];
        }
    }

    static fromJS(data: any): ExportTableColumnDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTableColumnDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["isExport"] = this.isExport;
        data["sortable"] = this.sortable;
        return data;
    }
}

export interface IExportTableColumnDefinition {
    key?: string | undefined;
    label?: string | undefined;
    isExport?: boolean;
    sortable?: boolean;
}

export class ExportTableResponse implements IExportTableResponse {
    totalCount?: number;
    rows?: { [key: string]: any; }[] | undefined;

    constructor(data?: IExportTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        return data;
    }
}

export interface IExportTableResponse {
    totalCount?: number;
    rows?: { [key: string]: any; }[] | undefined;
}

export class ProjectLightViewModel implements IProjectLightViewModel {
    id?: string;
    label?: string | undefined;
    clientId?: string | undefined;
    externalId?: string | undefined;
    client?: ClientLightViewModel | undefined;

    constructor(data?: IProjectLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.clientId = _data["clientId"];
            this.externalId = _data["externalId"];
            this.client = _data["client"] ? ClientLightViewModel.fromJS(_data["client"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["clientId"] = this.clientId;
        data["externalId"] = this.externalId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectLightViewModel {
    id?: string;
    label?: string | undefined;
    clientId?: string | undefined;
    externalId?: string | undefined;
    client?: ClientLightViewModel | undefined;
}

export class ProjectViewModel extends ProjectLightViewModel implements IProjectViewModel {
    isBillable?: boolean;
    amount?: number | undefined;
    client?: ClientViewModel | undefined;
    task?: TaskProjectViewModel | undefined;
    projectStatus?: ReferentielViewModel | undefined;
    isDeleted?: boolean;
    estimatedEndDate?: Date | undefined;
    estimatedStartDate?: Date | undefined;
    ouverteALaSaisie?: Date | undefined;
    responsables?: UserLightViewModel[] | undefined;
    commentaire?: string | undefined;
    tags?: TagProjectViewModel[] | undefined;
    commerciaux?: UserLightViewModel[] | undefined;
    totalPlannedTime?: number | undefined;
    totalInputTime?: number | undefined;
    totalInputNightTime?: number | undefined;
    totalAbsenceTime?: number | undefined;
    montantMo?: number | undefined;

    constructor(data?: IProjectViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isBillable = _data["isBillable"];
            this.amount = _data["amount"];
            this.client = _data["client"] ? ClientViewModel.fromJS(_data["client"]) : <any>undefined;
            this.task = _data["task"] ? TaskProjectViewModel.fromJS(_data["task"]) : <any>undefined;
            this.projectStatus = _data["projectStatus"] ? ReferentielViewModel.fromJS(_data["projectStatus"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.estimatedEndDate = _data["estimatedEndDate"] ? new Date(_data["estimatedEndDate"].toString()) : <any>undefined;
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            this.ouverteALaSaisie = _data["ouverteALaSaisie"] ? new Date(_data["ouverteALaSaisie"].toString()) : <any>undefined;
            if (Array.isArray(_data["responsables"])) {
                this.responsables = [] as any;
                for (let item of _data["responsables"])
                    this.responsables!.push(UserLightViewModel.fromJS(item));
            }
            this.commentaire = _data["commentaire"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagProjectViewModel.fromJS(item));
            }
            if (Array.isArray(_data["commerciaux"])) {
                this.commerciaux = [] as any;
                for (let item of _data["commerciaux"])
                    this.commerciaux!.push(UserLightViewModel.fromJS(item));
            }
            this.totalPlannedTime = _data["totalPlannedTime"];
            this.totalInputTime = _data["totalInputTime"];
            this.totalInputNightTime = _data["totalInputNightTime"];
            this.totalAbsenceTime = _data["totalAbsenceTime"];
            this.montantMo = _data["montantMo"];
        }
    }

    static fromJS(data: any): ProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBillable"] = this.isBillable;
        data["amount"] = this.amount;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["projectStatus"] = this.projectStatus ? this.projectStatus.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["estimatedEndDate"] = this.estimatedEndDate ? this.estimatedEndDate.toISOString() : <any>undefined;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        data["ouverteALaSaisie"] = this.ouverteALaSaisie ? this.ouverteALaSaisie.toISOString() : <any>undefined;
        if (Array.isArray(this.responsables)) {
            data["responsables"] = [];
            for (let item of this.responsables)
                data["responsables"].push(item.toJSON());
        }
        data["commentaire"] = this.commentaire;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.commerciaux)) {
            data["commerciaux"] = [];
            for (let item of this.commerciaux)
                data["commerciaux"].push(item.toJSON());
        }
        data["totalPlannedTime"] = this.totalPlannedTime;
        data["totalInputTime"] = this.totalInputTime;
        data["totalInputNightTime"] = this.totalInputNightTime;
        data["totalAbsenceTime"] = this.totalAbsenceTime;
        data["montantMo"] = this.montantMo;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectViewModel extends IProjectLightViewModel {
    isBillable?: boolean;
    amount?: number | undefined;
    client?: ClientViewModel | undefined;
    task?: TaskProjectViewModel | undefined;
    projectStatus?: ReferentielViewModel | undefined;
    isDeleted?: boolean;
    estimatedEndDate?: Date | undefined;
    estimatedStartDate?: Date | undefined;
    ouverteALaSaisie?: Date | undefined;
    responsables?: UserLightViewModel[] | undefined;
    commentaire?: string | undefined;
    tags?: TagProjectViewModel[] | undefined;
    commerciaux?: UserLightViewModel[] | undefined;
    totalPlannedTime?: number | undefined;
    totalInputTime?: number | undefined;
    totalInputNightTime?: number | undefined;
    totalAbsenceTime?: number | undefined;
    montantMo?: number | undefined;
}

export class ClientLightViewModel implements IClientLightViewModel {
    id?: string;
    externalId?: string | undefined;
    name?: string | undefined;

    constructor(data?: IClientLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClientLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        return data;
    }
}

export interface IClientLightViewModel {
    id?: string;
    externalId?: string | undefined;
    name?: string | undefined;
}

export class ClientViewModel extends ClientLightViewModel implements IClientViewModel {
    firstname?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;

    constructor(data?: IClientViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstname = _data["firstname"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
        }
    }

    static fromJS(data: any): ClientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        super.toJSON(data);
        return data;
    }
}

export interface IClientViewModel extends IClientLightViewModel {
    firstname?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
}

export class TaskProjectLightViewModel implements ITaskProjectLightViewModel {
    id?: string;
    taskProjectLabel?: string | undefined;

    constructor(data?: ITaskProjectLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskProjectLabel = _data["taskProjectLabel"];
        }
    }

    static fromJS(data: any): TaskProjectLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProjectLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskProjectLabel"] = this.taskProjectLabel;
        return data;
    }
}

export interface ITaskProjectLightViewModel {
    id?: string;
    taskProjectLabel?: string | undefined;
}

export class TaskProjectViewModel extends TaskProjectLightViewModel implements ITaskProjectViewModel {
    taskRefId?: string | undefined;
    externalCode?: string | undefined;
    statusTask?: ReferentielViewModel | undefined;
    timePlanned?: number | undefined;
    tagsCategory?: string[] | undefined;

    constructor(data?: ITaskProjectViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskRefId = _data["taskRefId"];
            this.externalCode = _data["externalCode"];
            this.statusTask = _data["statusTask"] ? ReferentielViewModel.fromJS(_data["statusTask"]) : <any>undefined;
            this.timePlanned = _data["timePlanned"];
            if (Array.isArray(_data["tagsCategory"])) {
                this.tagsCategory = [] as any;
                for (let item of _data["tagsCategory"])
                    this.tagsCategory!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskRefId"] = this.taskRefId;
        data["externalCode"] = this.externalCode;
        data["statusTask"] = this.statusTask ? this.statusTask.toJSON() : <any>undefined;
        data["timePlanned"] = this.timePlanned;
        if (Array.isArray(this.tagsCategory)) {
            data["tagsCategory"] = [];
            for (let item of this.tagsCategory)
                data["tagsCategory"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITaskProjectViewModel extends ITaskProjectLightViewModel {
    taskRefId?: string | undefined;
    externalCode?: string | undefined;
    statusTask?: ReferentielViewModel | undefined;
    timePlanned?: number | undefined;
    tagsCategory?: string[] | undefined;
}

export class ReferentielViewModel implements IReferentielViewModel {
    key?: string | undefined;
    label?: string | undefined;

    constructor(data?: IReferentielViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ReferentielViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentielViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        return data;
    }
}

export interface IReferentielViewModel {
    key?: string | undefined;
    label?: string | undefined;
}

export class UserLightViewModel implements IUserLightViewModel {
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    aspNetUserId?: string | undefined;
    userName?: string | undefined;
    externalId?: string | undefined;
    refRole?: ReferentielStringViewModel | undefined;
    role?: string | undefined;
    deleted?: boolean;
    accessAllChantier?: boolean;
    canAddTaskOnChantier?: boolean;

    constructor(data?: IUserLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.aspNetUserId = _data["aspNetUserId"];
            this.userName = _data["userName"];
            this.externalId = _data["externalId"];
            this.refRole = _data["refRole"] ? ReferentielStringViewModel.fromJS(_data["refRole"]) : <any>undefined;
            this.role = _data["role"];
            this.deleted = _data["deleted"];
            this.accessAllChantier = _data["accessAllChantier"];
            this.canAddTaskOnChantier = _data["canAddTaskOnChantier"];
        }
    }

    static fromJS(data: any): UserLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["aspNetUserId"] = this.aspNetUserId;
        data["userName"] = this.userName;
        data["externalId"] = this.externalId;
        data["refRole"] = this.refRole ? this.refRole.toJSON() : <any>undefined;
        data["role"] = this.role;
        data["deleted"] = this.deleted;
        data["accessAllChantier"] = this.accessAllChantier;
        data["canAddTaskOnChantier"] = this.canAddTaskOnChantier;
        return data;
    }
}

export interface IUserLightViewModel {
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    aspNetUserId?: string | undefined;
    userName?: string | undefined;
    externalId?: string | undefined;
    refRole?: ReferentielStringViewModel | undefined;
    role?: string | undefined;
    deleted?: boolean;
    accessAllChantier?: boolean;
    canAddTaskOnChantier?: boolean;
}

export class ReferentielStringViewModel implements IReferentielStringViewModel {
    key?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;

    constructor(data?: IReferentielStringViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ReferentielStringViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentielStringViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["description"] = this.description;
        return data;
    }
}

export interface IReferentielStringViewModel {
    key?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
}

export class TagProjectViewModel implements ITagProjectViewModel {
    id?: string;
    label?: string | undefined;
    color?: string | undefined;

    constructor(data?: ITagProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TagProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["color"] = this.color;
        return data;
    }
}

export interface ITagProjectViewModel {
    id?: string;
    label?: string | undefined;
    color?: string | undefined;
}

export class GetProjetsForInputResponse implements IGetProjetsForInputResponse {
    totalResult?: number;
    data?: GetProjetsForInputViewModel[] | undefined;

    constructor(data?: IGetProjetsForInputResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResult = _data["totalResult"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetProjetsForInputViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjetsForInputResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjetsForInputResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResult"] = this.totalResult;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjetsForInputResponse {
    totalResult?: number;
    data?: GetProjetsForInputViewModel[] | undefined;
}

export class GetProjetsForInputViewModel implements IGetProjetsForInputViewModel {
    id?: string;
    label?: string | undefined;
    externalId?: string | undefined;
    client?: GetClientProjetsForInputViewModel | undefined;

    constructor(data?: IGetProjetsForInputViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.externalId = _data["externalId"];
            this.client = _data["client"] ? GetClientProjetsForInputViewModel.fromJS(_data["client"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjetsForInputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjetsForInputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["externalId"] = this.externalId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProjetsForInputViewModel {
    id?: string;
    label?: string | undefined;
    externalId?: string | undefined;
    client?: GetClientProjetsForInputViewModel | undefined;
}

export class GetClientProjetsForInputViewModel implements IGetClientProjetsForInputViewModel {
    id?: string;
    name?: string | undefined;
    firstname?: string | undefined;

    constructor(data?: IGetClientProjetsForInputViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
        }
    }

    static fromJS(data: any): GetClientProjetsForInputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientProjetsForInputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        return data;
    }
}

export interface IGetClientProjetsForInputViewModel {
    id?: string;
    name?: string | undefined;
    firstname?: string | undefined;
}

export class PagedResultOfProjectViewModel implements IPagedResultOfProjectViewModel {
    totalCount?: number;
    data?: ProjectViewModel[] | undefined;

    constructor(data?: IPagedResultOfProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProjectViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfProjectViewModel {
    totalCount?: number;
    data?: ProjectViewModel[] | undefined;
}

export class DocumentModel implements IDocumentModel {
    url?: string | undefined;

    constructor(data?: IDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IDocumentModel {
    url?: string | undefined;
}

export class ProjetReponse implements IProjetReponse {
    id?: string;

    constructor(data?: IProjetReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjetReponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjetReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IProjetReponse {
    id?: string;
}

export class CommentCommand implements ICommentCommand {
    commentaire?: string | undefined;

    constructor(data?: ICommentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentaire = _data["commentaire"];
        }
    }

    static fromJS(data: any): CommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentaire"] = this.commentaire;
        return data;
    }
}

export interface ICommentCommand {
    commentaire?: string | undefined;
}

export class ProjetCommand extends CommentCommand implements IProjetCommand {
    label?: string | undefined;
    externalId?: string | undefined;
    clientId?: string | undefined;
    amount?: number | undefined;
    projectStatus?: ProjectStatus;
    isBillable?: boolean;
    estimatedEndDate?: Date | undefined;
    estimatedStartDate?: Date | undefined;
    responsablesId?: string[] | undefined;
    commerciauxId?: string[] | undefined;
    ouverteALaSaisie?: Date | undefined;
    tagIds?: string[] | undefined;

    constructor(data?: IProjetCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"];
            this.externalId = _data["externalId"];
            this.clientId = _data["clientId"];
            this.amount = _data["amount"];
            this.projectStatus = _data["projectStatus"];
            this.isBillable = _data["isBillable"];
            this.estimatedEndDate = _data["estimatedEndDate"] ? new Date(_data["estimatedEndDate"].toString()) : <any>undefined;
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["responsablesId"])) {
                this.responsablesId = [] as any;
                for (let item of _data["responsablesId"])
                    this.responsablesId!.push(item);
            }
            if (Array.isArray(_data["commerciauxId"])) {
                this.commerciauxId = [] as any;
                for (let item of _data["commerciauxId"])
                    this.commerciauxId!.push(item);
            }
            this.ouverteALaSaisie = _data["ouverteALaSaisie"] ? new Date(_data["ouverteALaSaisie"].toString()) : <any>undefined;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProjetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["externalId"] = this.externalId;
        data["clientId"] = this.clientId;
        data["amount"] = this.amount;
        data["projectStatus"] = this.projectStatus;
        data["isBillable"] = this.isBillable;
        data["estimatedEndDate"] = this.estimatedEndDate ? this.estimatedEndDate.toISOString() : <any>undefined;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        if (Array.isArray(this.responsablesId)) {
            data["responsablesId"] = [];
            for (let item of this.responsablesId)
                data["responsablesId"].push(item);
        }
        if (Array.isArray(this.commerciauxId)) {
            data["commerciauxId"] = [];
            for (let item of this.commerciauxId)
                data["commerciauxId"].push(item);
        }
        data["ouverteALaSaisie"] = this.ouverteALaSaisie ? this.ouverteALaSaisie.toISOString() : <any>undefined;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProjetCommand extends ICommentCommand {
    label?: string | undefined;
    externalId?: string | undefined;
    clientId?: string | undefined;
    amount?: number | undefined;
    projectStatus?: ProjectStatus;
    isBillable?: boolean;
    estimatedEndDate?: Date | undefined;
    estimatedStartDate?: Date | undefined;
    responsablesId?: string[] | undefined;
    commerciauxId?: string[] | undefined;
    ouverteALaSaisie?: Date | undefined;
    tagIds?: string[] | undefined;
}

export class TaskProjectCommand implements ITaskProjectCommand {
    label?: string | undefined;
    description?: string | undefined;
    statusTask?: StatusTask;
    timePlanned?: number | undefined;
    externalCode?: string | undefined;
    tagsCategoryIds?: string[] | undefined;
    taskRefId?: string | undefined;

    constructor(data?: ITaskProjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.description = _data["description"];
            this.statusTask = _data["statusTask"];
            this.timePlanned = _data["timePlanned"];
            this.externalCode = _data["externalCode"];
            if (Array.isArray(_data["tagsCategoryIds"])) {
                this.tagsCategoryIds = [] as any;
                for (let item of _data["tagsCategoryIds"])
                    this.tagsCategoryIds!.push(item);
            }
            this.taskRefId = _data["taskRefId"];
        }
    }

    static fromJS(data: any): TaskProjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["description"] = this.description;
        data["statusTask"] = this.statusTask;
        data["timePlanned"] = this.timePlanned;
        data["externalCode"] = this.externalCode;
        if (Array.isArray(this.tagsCategoryIds)) {
            data["tagsCategoryIds"] = [];
            for (let item of this.tagsCategoryIds)
                data["tagsCategoryIds"].push(item);
        }
        data["taskRefId"] = this.taskRefId;
        return data;
    }
}

export interface ITaskProjectCommand {
    label?: string | undefined;
    description?: string | undefined;
    statusTask?: StatusTask;
    timePlanned?: number | undefined;
    externalCode?: string | undefined;
    tagsCategoryIds?: string[] | undefined;
    taskRefId?: string | undefined;
}

export class WeekReportUtilisateurResponse implements IWeekReportUtilisateurResponse {
    result?: WeeksReportUtilisateur[] | undefined;

    constructor(data?: IWeekReportUtilisateurResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(WeeksReportUtilisateur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeekReportUtilisateurResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WeekReportUtilisateurResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeekReportUtilisateurResponse {
    result?: WeeksReportUtilisateur[] | undefined;
}

export class WeeksReportUtilisateur implements IWeeksReportUtilisateur {
    utilisateur?: WeekReportUtilisateurInfo | undefined;
    userWeekReport?: WeekReportUtilisateur[] | undefined;

    constructor(data?: IWeeksReportUtilisateur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilisateur = _data["utilisateur"] ? WeekReportUtilisateurInfo.fromJS(_data["utilisateur"]) : <any>undefined;
            if (Array.isArray(_data["userWeekReport"])) {
                this.userWeekReport = [] as any;
                for (let item of _data["userWeekReport"])
                    this.userWeekReport!.push(WeekReportUtilisateur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeeksReportUtilisateur {
        data = typeof data === 'object' ? data : {};
        let result = new WeeksReportUtilisateur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        if (Array.isArray(this.userWeekReport)) {
            data["userWeekReport"] = [];
            for (let item of this.userWeekReport)
                data["userWeekReport"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeeksReportUtilisateur {
    utilisateur?: WeekReportUtilisateurInfo | undefined;
    userWeekReport?: WeekReportUtilisateur[] | undefined;
}

export class WeekReportUtilisateurInfo implements IWeekReportUtilisateurInfo {
    id?: string;
    nom?: string | undefined;
    externalId?: string | undefined;
    prenom?: string | undefined;

    constructor(data?: IWeekReportUtilisateurInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nom = _data["nom"];
            this.externalId = _data["externalId"];
            this.prenom = _data["prenom"];
        }
    }

    static fromJS(data: any): WeekReportUtilisateurInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WeekReportUtilisateurInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nom"] = this.nom;
        data["externalId"] = this.externalId;
        data["prenom"] = this.prenom;
        return data;
    }
}

export interface IWeekReportUtilisateurInfo {
    id?: string;
    nom?: string | undefined;
    externalId?: string | undefined;
    prenom?: string | undefined;
}

export class WeekReportUtilisateur implements IWeekReportUtilisateur {
    numSemaine?: number | undefined;
    timeSheetValidationId?: string | undefined;
    timeSheet?: WeekReportTimeSheet | undefined;
    weekTimeSheetStatus?: WeekTimeSheetStatus;
    validationLevel?: ValidationLevel;

    constructor(data?: IWeekReportUtilisateur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numSemaine = _data["numSemaine"];
            this.timeSheetValidationId = _data["timeSheetValidationId"];
            this.timeSheet = _data["timeSheet"] ? WeekReportTimeSheet.fromJS(_data["timeSheet"]) : <any>undefined;
            this.weekTimeSheetStatus = _data["weekTimeSheetStatus"];
            this.validationLevel = _data["validationLevel"];
        }
    }

    static fromJS(data: any): WeekReportUtilisateur {
        data = typeof data === 'object' ? data : {};
        let result = new WeekReportUtilisateur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numSemaine"] = this.numSemaine;
        data["timeSheetValidationId"] = this.timeSheetValidationId;
        data["timeSheet"] = this.timeSheet ? this.timeSheet.toJSON() : <any>undefined;
        data["weekTimeSheetStatus"] = this.weekTimeSheetStatus;
        data["validationLevel"] = this.validationLevel;
        return data;
    }
}

export interface IWeekReportUtilisateur {
    numSemaine?: number | undefined;
    timeSheetValidationId?: string | undefined;
    timeSheet?: WeekReportTimeSheet | undefined;
    weekTimeSheetStatus?: WeekTimeSheetStatus;
    validationLevel?: ValidationLevel;
}

export class WeekReportTimeSheet implements IWeekReportTimeSheet {
    tempsTrajet?: number | undefined;
    heuresTravaillees?: number | undefined;
    heuresTravailleesNuit?: number | undefined;
    absences?: number | undefined;
    nbGdDeplacement?: number | undefined;
    nbPanierRepas?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    montantMo?: number | undefined;
    timeSheetStatus?: TimeSheetStatus;
    prime?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    validationStatus?: ValidationStatus | undefined;
    validationLevel?: ValidationLevel | undefined;

    constructor(data?: IWeekReportTimeSheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tempsTrajet = _data["tempsTrajet"];
            this.heuresTravaillees = _data["heuresTravaillees"];
            this.heuresTravailleesNuit = _data["heuresTravailleesNuit"];
            this.absences = _data["absences"];
            this.nbGdDeplacement = _data["nbGdDeplacement"];
            this.nbPanierRepas = _data["nbPanierRepas"];
            this.kmPro = _data["kmPro"];
            this.kmPerso = _data["kmPerso"];
            this.montantMo = _data["montantMo"];
            this.timeSheetStatus = _data["timeSheetStatus"];
            this.prime = _data["prime"];
            this.tempsTrajetSurHeureTravaillees = _data["tempsTrajetSurHeureTravaillees"];
            this.validationStatus = _data["validationStatus"];
            this.validationLevel = _data["validationLevel"];
        }
    }

    static fromJS(data: any): WeekReportTimeSheet {
        data = typeof data === 'object' ? data : {};
        let result = new WeekReportTimeSheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tempsTrajet"] = this.tempsTrajet;
        data["heuresTravaillees"] = this.heuresTravaillees;
        data["heuresTravailleesNuit"] = this.heuresTravailleesNuit;
        data["absences"] = this.absences;
        data["nbGdDeplacement"] = this.nbGdDeplacement;
        data["nbPanierRepas"] = this.nbPanierRepas;
        data["kmPro"] = this.kmPro;
        data["kmPerso"] = this.kmPerso;
        data["montantMo"] = this.montantMo;
        data["timeSheetStatus"] = this.timeSheetStatus;
        data["prime"] = this.prime;
        data["tempsTrajetSurHeureTravaillees"] = this.tempsTrajetSurHeureTravaillees;
        data["validationStatus"] = this.validationStatus;
        data["validationLevel"] = this.validationLevel;
        return data;
    }
}

export interface IWeekReportTimeSheet {
    tempsTrajet?: number | undefined;
    heuresTravaillees?: number | undefined;
    heuresTravailleesNuit?: number | undefined;
    absences?: number | undefined;
    nbGdDeplacement?: number | undefined;
    nbPanierRepas?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    montantMo?: number | undefined;
    timeSheetStatus?: TimeSheetStatus;
    prime?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    validationStatus?: ValidationStatus | undefined;
    validationLevel?: ValidationLevel | undefined;
}

export enum WeekTimeSheetStatus {
    NOT_CREATED = 0,
    CREATED = 1,
    VALIDATED = 2,
    REFUSED = 3,
}

export class ReportsCriteria implements IReportsCriteria {
    startDate?: Date;
    endDate?: Date;
    billableTask?: boolean;
    userIds?: string[] | undefined;
    projects?: string[] | undefined;
    clients?: string[] | undefined;
    noClient?: boolean;

    constructor(data?: IReportsCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.billableTask = _data["billableTask"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(item);
            }
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(item);
            }
            this.noClient = _data["noClient"];
        }
    }

    static fromJS(data: any): ReportsCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["billableTask"] = this.billableTask;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item);
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item);
        }
        data["noClient"] = this.noClient;
        return data;
    }
}

export interface IReportsCriteria {
    startDate?: Date;
    endDate?: Date;
    billableTask?: boolean;
    userIds?: string[] | undefined;
    projects?: string[] | undefined;
    clients?: string[] | undefined;
    noClient?: boolean;
}

export class GroupingProject implements IGroupingProject {
    project?: ProjectViewModel | undefined;
    utilisateurs?: UtilisateurReportingViewModel[] | undefined;
    phases?: TaskReportingViewModel[] | undefined;
    tasks?: ReadTimeSheetInputViewModel[] | undefined;

    constructor(data?: IGroupingProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectViewModel.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["utilisateurs"])) {
                this.utilisateurs = [] as any;
                for (let item of _data["utilisateurs"])
                    this.utilisateurs!.push(UtilisateurReportingViewModel.fromJS(item));
            }
            if (Array.isArray(_data["phases"])) {
                this.phases = [] as any;
                for (let item of _data["phases"])
                    this.phases!.push(TaskReportingViewModel.fromJS(item));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ReadTimeSheetInputViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupingProject {
        data = typeof data === 'object' ? data : {};
        let result = new GroupingProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.utilisateurs)) {
            data["utilisateurs"] = [];
            for (let item of this.utilisateurs)
                data["utilisateurs"].push(item.toJSON());
        }
        if (Array.isArray(this.phases)) {
            data["phases"] = [];
            for (let item of this.phases)
                data["phases"].push(item.toJSON());
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupingProject {
    project?: ProjectViewModel | undefined;
    utilisateurs?: UtilisateurReportingViewModel[] | undefined;
    phases?: TaskReportingViewModel[] | undefined;
    tasks?: ReadTimeSheetInputViewModel[] | undefined;
}

export class UtilisateurReportingViewModel implements IUtilisateurReportingViewModel {
    utilisateur?: UserLightViewModelWithCost | undefined;
    totalTime?: number | undefined;
    montantMo?: number | undefined;

    constructor(data?: IUtilisateurReportingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilisateur = _data["utilisateur"] ? UserLightViewModelWithCost.fromJS(_data["utilisateur"]) : <any>undefined;
            this.totalTime = _data["totalTime"];
            this.montantMo = _data["montantMo"];
        }
    }

    static fromJS(data: any): UtilisateurReportingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UtilisateurReportingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        data["totalTime"] = this.totalTime;
        data["montantMo"] = this.montantMo;
        return data;
    }
}

export interface IUtilisateurReportingViewModel {
    utilisateur?: UserLightViewModelWithCost | undefined;
    totalTime?: number | undefined;
    montantMo?: number | undefined;
}

export class UserLightViewModelWithCost extends UserLightViewModel implements IUserLightViewModelWithCost {
    couts?: CoutViewModel[] | undefined;
    coutHoraire?: number | undefined;

    constructor(data?: IUserLightViewModelWithCost) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["couts"])) {
                this.couts = [] as any;
                for (let item of _data["couts"])
                    this.couts!.push(CoutViewModel.fromJS(item));
            }
            this.coutHoraire = _data["coutHoraire"];
        }
    }

    static fromJS(data: any): UserLightViewModelWithCost {
        data = typeof data === 'object' ? data : {};
        let result = new UserLightViewModelWithCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.couts)) {
            data["couts"] = [];
            for (let item of this.couts)
                data["couts"].push(item.toJSON());
        }
        data["coutHoraire"] = this.coutHoraire;
        super.toJSON(data);
        return data;
    }
}

export interface IUserLightViewModelWithCost extends IUserLightViewModel {
    couts?: CoutViewModel[] | undefined;
    coutHoraire?: number | undefined;
}

export class CoutViewModel implements ICoutViewModel {
    start?: Date;
    tauxHoraire?: number | undefined;

    constructor(data?: ICoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.tauxHoraire = _data["tauxHoraire"];
        }
    }

    static fromJS(data: any): CoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["tauxHoraire"] = this.tauxHoraire;
        return data;
    }
}

export interface ICoutViewModel {
    start?: Date;
    tauxHoraire?: number | undefined;
}

export class TaskReportingViewModel implements ITaskReportingViewModel {
    task?: TaskProjectLightViewModel | undefined;
    averageCost?: number | undefined;
    totalTime?: number | undefined;
    montantMo?: number | undefined;

    constructor(data?: ITaskReportingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.task = _data["task"] ? TaskProjectLightViewModel.fromJS(_data["task"]) : <any>undefined;
            this.averageCost = _data["averageCost"];
            this.totalTime = _data["totalTime"];
            this.montantMo = _data["montantMo"];
        }
    }

    static fromJS(data: any): TaskReportingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskReportingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["averageCost"] = this.averageCost;
        data["totalTime"] = this.totalTime;
        data["montantMo"] = this.montantMo;
        return data;
    }
}

export interface ITaskReportingViewModel {
    task?: TaskProjectLightViewModel | undefined;
    averageCost?: number | undefined;
    totalTime?: number | undefined;
    montantMo?: number | undefined;
}

export abstract class TimeInput implements ITimeInput {
    id?: string;
    time?: number | undefined;
    comment?: string | undefined;
    timeSheet?: ReadTimeSheetViewModel2 | undefined;
    createdBy?: string | undefined;

    constructor(data?: ITimeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"];
            this.comment = _data["comment"];
            this.timeSheet = _data["timeSheet"] ? ReadTimeSheetViewModel2.fromJS(_data["timeSheet"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): TimeInput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TimeInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time;
        data["comment"] = this.comment;
        data["timeSheet"] = this.timeSheet ? this.timeSheet.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface ITimeInput {
    id?: string;
    time?: number | undefined;
    comment?: string | undefined;
    timeSheet?: ReadTimeSheetViewModel2 | undefined;
    createdBy?: string | undefined;
}

export class ReadTimeSheetInputViewModel extends TimeInput implements IReadTimeSheetInputViewModel {
    task?: TaskProjectLightViewModel | undefined;
    client?: ClientLightViewModel | undefined;
    project?: ProjectLightViewModel | undefined;
    heuresDeNuit?: boolean;

    constructor(data?: IReadTimeSheetInputViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.task = _data["task"] ? TaskProjectLightViewModel.fromJS(_data["task"]) : <any>undefined;
            this.client = _data["client"] ? ClientLightViewModel.fromJS(_data["client"]) : <any>undefined;
            this.project = _data["project"] ? ProjectLightViewModel.fromJS(_data["project"]) : <any>undefined;
            this.heuresDeNuit = _data["heuresDeNuit"];
        }
    }

    static fromJS(data: any): ReadTimeSheetInputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadTimeSheetInputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["heuresDeNuit"] = this.heuresDeNuit;
        super.toJSON(data);
        return data;
    }
}

export interface IReadTimeSheetInputViewModel extends ITimeInput {
    task?: TaskProjectLightViewModel | undefined;
    client?: ClientLightViewModel | undefined;
    project?: ProjectLightViewModel | undefined;
    heuresDeNuit?: boolean;
}

export class ReadTimeSheetViewModel2 implements IReadTimeSheetViewModel2 {
    id?: string;
    validTimeSheetId?: string | undefined;
    sheetDate?: Date;
    timeSheetStatus?: ReferentielViewModel | undefined;
    utilisateur?: UserLightViewModelWithCost | undefined;
    coutJournalier?: number | undefined;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    tempsTrajet?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
    total?: number | undefined;
    totalNuit?: number | undefined;
    montant?: number | undefined;
    createdBy?: string | undefined;
    prime?: number | undefined;

    constructor(data?: IReadTimeSheetViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validTimeSheetId = _data["validTimeSheetId"];
            this.sheetDate = _data["sheetDate"] ? new Date(_data["sheetDate"].toString()) : <any>undefined;
            this.timeSheetStatus = _data["timeSheetStatus"] ? ReferentielViewModel.fromJS(_data["timeSheetStatus"]) : <any>undefined;
            this.utilisateur = _data["utilisateur"] ? UserLightViewModelWithCost.fromJS(_data["utilisateur"]) : <any>undefined;
            this.coutJournalier = _data["coutJournalier"];
            this.panierRepas = _data["panierRepas"];
            this.grandDeplacement = _data["grandDeplacement"];
            this.tempsTrajet = _data["tempsTrajet"];
            this.kmPro = _data["kmPro"];
            this.kmPerso = _data["kmPerso"];
            this.kmPersoJustification = _data["kmPersoJustification"];
            this.total = _data["total"];
            this.totalNuit = _data["totalNuit"];
            this.montant = _data["montant"];
            this.createdBy = _data["createdBy"];
            this.prime = _data["prime"];
        }
    }

    static fromJS(data: any): ReadTimeSheetViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new ReadTimeSheetViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validTimeSheetId"] = this.validTimeSheetId;
        data["sheetDate"] = this.sheetDate ? this.sheetDate.toISOString() : <any>undefined;
        data["timeSheetStatus"] = this.timeSheetStatus ? this.timeSheetStatus.toJSON() : <any>undefined;
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        data["coutJournalier"] = this.coutJournalier;
        data["panierRepas"] = this.panierRepas;
        data["grandDeplacement"] = this.grandDeplacement;
        data["tempsTrajet"] = this.tempsTrajet;
        data["kmPro"] = this.kmPro;
        data["kmPerso"] = this.kmPerso;
        data["kmPersoJustification"] = this.kmPersoJustification;
        data["total"] = this.total;
        data["totalNuit"] = this.totalNuit;
        data["montant"] = this.montant;
        data["createdBy"] = this.createdBy;
        data["prime"] = this.prime;
        return data;
    }
}

export interface IReadTimeSheetViewModel2 {
    id?: string;
    validTimeSheetId?: string | undefined;
    sheetDate?: Date;
    timeSheetStatus?: ReferentielViewModel | undefined;
    utilisateur?: UserLightViewModelWithCost | undefined;
    coutJournalier?: number | undefined;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    tempsTrajet?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
    total?: number | undefined;
    totalNuit?: number | undefined;
    montant?: number | undefined;
    createdBy?: string | undefined;
    prime?: number | undefined;
}

export class SettingsViewModel implements ISettingsViewModel {
    id?: string;
    hoursDelay?: number | undefined;
    isManagePanierRepas?: boolean;
    isManageGrandDeplacement?: boolean;
    isManageTempsTrajet?: boolean;
    isManageAbsences?: boolean;
    manageValidation?: boolean;
    alerteHoursWeekMax?: number | undefined;
    alerteHoursDayMax?: number | undefined;
    isManageKmsPerso?: boolean;
    isManageKmsPro?: boolean;
    isManageCost?: boolean;
    isManageResponsable?: boolean;
    isManageCommercial?: boolean;
    isEditTimeByAdmin?: boolean;
    displayWeekEnd?: boolean;
    isManageNightHours?: boolean;
    primeSamedi?: number | undefined;
    isTempsTrajetSurHeureTravaillees?: boolean;
    exportReportName?: string | undefined;
    isManageExportErp?: boolean;

    constructor(data?: ISettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hoursDelay = _data["hoursDelay"];
            this.isManagePanierRepas = _data["isManagePanierRepas"];
            this.isManageGrandDeplacement = _data["isManageGrandDeplacement"];
            this.isManageTempsTrajet = _data["isManageTempsTrajet"];
            this.isManageAbsences = _data["isManageAbsences"];
            this.manageValidation = _data["manageValidation"];
            this.alerteHoursWeekMax = _data["alerteHoursWeekMax"];
            this.alerteHoursDayMax = _data["alerteHoursDayMax"];
            this.isManageKmsPerso = _data["isManageKmsPerso"];
            this.isManageKmsPro = _data["isManageKmsPro"];
            this.isManageCost = _data["isManageCost"];
            this.isManageResponsable = _data["isManageResponsable"];
            this.isManageCommercial = _data["isManageCommercial"];
            this.isEditTimeByAdmin = _data["isEditTimeByAdmin"];
            this.displayWeekEnd = _data["displayWeekEnd"];
            this.isManageNightHours = _data["isManageNightHours"];
            this.primeSamedi = _data["primeSamedi"];
            this.isTempsTrajetSurHeureTravaillees = _data["isTempsTrajetSurHeureTravaillees"];
            this.exportReportName = _data["exportReportName"];
            this.isManageExportErp = _data["isManageExportErp"];
        }
    }

    static fromJS(data: any): SettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hoursDelay"] = this.hoursDelay;
        data["isManagePanierRepas"] = this.isManagePanierRepas;
        data["isManageGrandDeplacement"] = this.isManageGrandDeplacement;
        data["isManageTempsTrajet"] = this.isManageTempsTrajet;
        data["isManageAbsences"] = this.isManageAbsences;
        data["manageValidation"] = this.manageValidation;
        data["alerteHoursWeekMax"] = this.alerteHoursWeekMax;
        data["alerteHoursDayMax"] = this.alerteHoursDayMax;
        data["isManageKmsPerso"] = this.isManageKmsPerso;
        data["isManageKmsPro"] = this.isManageKmsPro;
        data["isManageCost"] = this.isManageCost;
        data["isManageResponsable"] = this.isManageResponsable;
        data["isManageCommercial"] = this.isManageCommercial;
        data["isEditTimeByAdmin"] = this.isEditTimeByAdmin;
        data["displayWeekEnd"] = this.displayWeekEnd;
        data["isManageNightHours"] = this.isManageNightHours;
        data["primeSamedi"] = this.primeSamedi;
        data["isTempsTrajetSurHeureTravaillees"] = this.isTempsTrajetSurHeureTravaillees;
        data["exportReportName"] = this.exportReportName;
        data["isManageExportErp"] = this.isManageExportErp;
        return data;
    }
}

export interface ISettingsViewModel {
    id?: string;
    hoursDelay?: number | undefined;
    isManagePanierRepas?: boolean;
    isManageGrandDeplacement?: boolean;
    isManageTempsTrajet?: boolean;
    isManageAbsences?: boolean;
    manageValidation?: boolean;
    alerteHoursWeekMax?: number | undefined;
    alerteHoursDayMax?: number | undefined;
    isManageKmsPerso?: boolean;
    isManageKmsPro?: boolean;
    isManageCost?: boolean;
    isManageResponsable?: boolean;
    isManageCommercial?: boolean;
    isEditTimeByAdmin?: boolean;
    displayWeekEnd?: boolean;
    isManageNightHours?: boolean;
    primeSamedi?: number | undefined;
    isTempsTrajetSurHeureTravaillees?: boolean;
    exportReportName?: string | undefined;
    isManageExportErp?: boolean;
}

export class SettingFeaturesOption implements ISettingFeaturesOption {
    key?: string | undefined;
    isAuthorized?: boolean;

    constructor(data?: ISettingFeaturesOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.isAuthorized = _data["isAuthorized"];
        }
    }

    static fromJS(data: any): SettingFeaturesOption {
        data = typeof data === 'object' ? data : {};
        let result = new SettingFeaturesOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["isAuthorized"] = this.isAuthorized;
        return data;
    }
}

export interface ISettingFeaturesOption {
    key?: string | undefined;
    isAuthorized?: boolean;
}

export class SettingCommand implements ISettingCommand {
    hoursDelay?: number | undefined;
    isManagePanierRepas?: boolean;
    isManageGrandDeplacement?: boolean;
    isManageTempsTrajet?: boolean;
    isManageKmsPro?: boolean;
    isManageKmsPerso?: boolean;
    manageValidation?: boolean;
    isManageAbsences?: boolean;
    displayWeekEnd?: boolean;
    isManageResponsable?: boolean;
    isManageCommercial?: boolean;
    isManageCost?: boolean;
    alerteHoursWeekMax?: number | undefined;
    alerteHoursDayMax?: number | undefined;
    isEditTimeByAdmin?: boolean;
    isManageNightHours?: boolean;
    primeSamedi?: number | undefined;
    isTempsTrajetSurHeureTravaillees?: boolean;

    constructor(data?: ISettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoursDelay = _data["hoursDelay"];
            this.isManagePanierRepas = _data["isManagePanierRepas"];
            this.isManageGrandDeplacement = _data["isManageGrandDeplacement"];
            this.isManageTempsTrajet = _data["isManageTempsTrajet"];
            this.isManageKmsPro = _data["isManageKmsPro"];
            this.isManageKmsPerso = _data["isManageKmsPerso"];
            this.manageValidation = _data["manageValidation"];
            this.isManageAbsences = _data["isManageAbsences"];
            this.displayWeekEnd = _data["displayWeekEnd"];
            this.isManageResponsable = _data["isManageResponsable"];
            this.isManageCommercial = _data["isManageCommercial"];
            this.isManageCost = _data["isManageCost"];
            this.alerteHoursWeekMax = _data["alerteHoursWeekMax"];
            this.alerteHoursDayMax = _data["alerteHoursDayMax"];
            this.isEditTimeByAdmin = _data["isEditTimeByAdmin"];
            this.isManageNightHours = _data["isManageNightHours"];
            this.primeSamedi = _data["primeSamedi"];
            this.isTempsTrajetSurHeureTravaillees = _data["isTempsTrajetSurHeureTravaillees"];
        }
    }

    static fromJS(data: any): SettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hoursDelay"] = this.hoursDelay;
        data["isManagePanierRepas"] = this.isManagePanierRepas;
        data["isManageGrandDeplacement"] = this.isManageGrandDeplacement;
        data["isManageTempsTrajet"] = this.isManageTempsTrajet;
        data["isManageKmsPro"] = this.isManageKmsPro;
        data["isManageKmsPerso"] = this.isManageKmsPerso;
        data["manageValidation"] = this.manageValidation;
        data["isManageAbsences"] = this.isManageAbsences;
        data["displayWeekEnd"] = this.displayWeekEnd;
        data["isManageResponsable"] = this.isManageResponsable;
        data["isManageCommercial"] = this.isManageCommercial;
        data["isManageCost"] = this.isManageCost;
        data["alerteHoursWeekMax"] = this.alerteHoursWeekMax;
        data["alerteHoursDayMax"] = this.alerteHoursDayMax;
        data["isEditTimeByAdmin"] = this.isEditTimeByAdmin;
        data["isManageNightHours"] = this.isManageNightHours;
        data["primeSamedi"] = this.primeSamedi;
        data["isTempsTrajetSurHeureTravaillees"] = this.isTempsTrajetSurHeureTravaillees;
        return data;
    }
}

export interface ISettingCommand {
    hoursDelay?: number | undefined;
    isManagePanierRepas?: boolean;
    isManageGrandDeplacement?: boolean;
    isManageTempsTrajet?: boolean;
    isManageKmsPro?: boolean;
    isManageKmsPerso?: boolean;
    manageValidation?: boolean;
    isManageAbsences?: boolean;
    displayWeekEnd?: boolean;
    isManageResponsable?: boolean;
    isManageCommercial?: boolean;
    isManageCost?: boolean;
    alerteHoursWeekMax?: number | undefined;
    alerteHoursDayMax?: number | undefined;
    isEditTimeByAdmin?: boolean;
    isManageNightHours?: boolean;
    primeSamedi?: number | undefined;
    isTempsTrajetSurHeureTravaillees?: boolean;
}

export class TagCategoryDto implements ITagCategoryDto {
    id?: string;
    categoryName?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: ITagCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryName = _data["categoryName"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TagCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryName"] = this.categoryName;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITagCategoryDto {
    id?: string;
    categoryName?: string | undefined;
    isDeleted?: boolean;
}

export class AddOrUpdateTagCategoryResponse implements IAddOrUpdateTagCategoryResponse {
    id?: string;

    constructor(data?: IAddOrUpdateTagCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddOrUpdateTagCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateTagCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAddOrUpdateTagCategoryResponse {
    id?: string;
}

export class TagCategoryCommanDto implements ITagCategoryCommanDto {
    categoryName?: string | undefined;

    constructor(data?: ITagCategoryCommanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): TagCategoryCommanDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCategoryCommanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface ITagCategoryCommanDto {
    categoryName?: string | undefined;
}

export class PagedResultOfReferentielTagViewModel implements IPagedResultOfReferentielTagViewModel {
    totalCount?: number;
    data?: ReferentielTagViewModel[] | undefined;

    constructor(data?: IPagedResultOfReferentielTagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReferentielTagViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfReferentielTagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfReferentielTagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfReferentielTagViewModel {
    totalCount?: number;
    data?: ReferentielTagViewModel[] | undefined;
}

export class ReferentielTagViewModel implements IReferentielTagViewModel {
    key?: string | undefined;
    label?: string | undefined;
    color?: string | undefined;

    constructor(data?: IReferentielTagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ReferentielTagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentielTagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["color"] = this.color;
        return data;
    }
}

export interface IReferentielTagViewModel {
    key?: string | undefined;
    label?: string | undefined;
    color?: string | undefined;
}

export class TagCommand implements ITagCommand {
    label?: string | undefined;
    color?: string | undefined;

    constructor(data?: ITagCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TagCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TagCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["color"] = this.color;
        return data;
    }
}

export interface ITagCommand {
    label?: string | undefined;
    color?: string | undefined;
}

export class PagedResultOfReferentielTaskViewModel implements IPagedResultOfReferentielTaskViewModel {
    totalCount?: number;
    data?: ReferentielTaskViewModel[] | undefined;

    constructor(data?: IPagedResultOfReferentielTaskViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReferentielTaskViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfReferentielTaskViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfReferentielTaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfReferentielTaskViewModel {
    totalCount?: number;
    data?: ReferentielTaskViewModel[] | undefined;
}

export class ReferentielTaskViewModel implements IReferentielTaskViewModel {
    key?: string | undefined;
    label?: string | undefined;
    tagsCategory?: TagCategoryViewModel[] | undefined;
    externalCode?: string | undefined;
    description?: string | undefined;
    addOnProjectCreated?: boolean;

    constructor(data?: IReferentielTaskViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            if (Array.isArray(_data["tagsCategory"])) {
                this.tagsCategory = [] as any;
                for (let item of _data["tagsCategory"])
                    this.tagsCategory!.push(TagCategoryViewModel.fromJS(item));
            }
            this.externalCode = _data["externalCode"];
            this.description = _data["description"];
            this.addOnProjectCreated = _data["addOnProjectCreated"];
        }
    }

    static fromJS(data: any): ReferentielTaskViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentielTaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        if (Array.isArray(this.tagsCategory)) {
            data["tagsCategory"] = [];
            for (let item of this.tagsCategory)
                data["tagsCategory"].push(item.toJSON());
        }
        data["externalCode"] = this.externalCode;
        data["description"] = this.description;
        data["addOnProjectCreated"] = this.addOnProjectCreated;
        return data;
    }
}

export interface IReferentielTaskViewModel {
    key?: string | undefined;
    label?: string | undefined;
    tagsCategory?: TagCategoryViewModel[] | undefined;
    externalCode?: string | undefined;
    description?: string | undefined;
    addOnProjectCreated?: boolean;
}

export class TagCategoryViewModel implements ITagCategoryViewModel {
    id?: string;
    label?: string | undefined;

    constructor(data?: ITagCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): TagCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface ITagCategoryViewModel {
    id?: string;
    label?: string | undefined;
}

export class TaskCommand implements ITaskCommand {
    label?: string | undefined;
    description?: string | undefined;
    externalCode?: string | undefined;
    tagsCategoryIds?: string[] | undefined;
    addOnProjectCreated?: boolean;

    constructor(data?: ITaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.description = _data["description"];
            this.externalCode = _data["externalCode"];
            if (Array.isArray(_data["tagsCategoryIds"])) {
                this.tagsCategoryIds = [] as any;
                for (let item of _data["tagsCategoryIds"])
                    this.tagsCategoryIds!.push(item);
            }
            this.addOnProjectCreated = _data["addOnProjectCreated"];
        }
    }

    static fromJS(data: any): TaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["description"] = this.description;
        data["externalCode"] = this.externalCode;
        if (Array.isArray(this.tagsCategoryIds)) {
            data["tagsCategoryIds"] = [];
            for (let item of this.tagsCategoryIds)
                data["tagsCategoryIds"].push(item);
        }
        data["addOnProjectCreated"] = this.addOnProjectCreated;
        return data;
    }
}

export interface ITaskCommand {
    label?: string | undefined;
    description?: string | undefined;
    externalCode?: string | undefined;
    tagsCategoryIds?: string[] | undefined;
    addOnProjectCreated?: boolean;
}

export class TimeSheetCriteria implements ITimeSheetCriteria {
    startDate?: Date;
    endDate?: Date | undefined;
    userIds?: string[] | undefined;

    constructor(data?: ITimeSheetCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TimeSheetCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface ITimeSheetCriteria {
    startDate?: Date;
    endDate?: Date | undefined;
    userIds?: string[] | undefined;
}

export enum Mode {
    HTML = 0,
    PDF = 1,
}

export class PagedResultOfClientViewModel implements IPagedResultOfClientViewModel {
    totalCount?: number;
    data?: ClientViewModel[] | undefined;

    constructor(data?: IPagedResultOfClientViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClientViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfClientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfClientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfClientViewModel {
    totalCount?: number;
    data?: ClientViewModel[] | undefined;
}

export class ClientCommand implements IClientCommand {
    name?: string | undefined;
    firstname?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IClientCommand {
    name?: string | undefined;
    firstname?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    externalId?: string | undefined;
}

export class GetTasksByTimeSheetIdRequestModel implements IGetTasksByTimeSheetIdRequestModel {
    timeSheetId?: string;

    constructor(data?: IGetTasksByTimeSheetIdRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSheetId = _data["timeSheetId"];
        }
    }

    static fromJS(data: any): GetTasksByTimeSheetIdRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksByTimeSheetIdRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSheetId"] = this.timeSheetId;
        return data;
    }
}

export interface IGetTasksByTimeSheetIdRequestModel {
    timeSheetId?: string;
}

export class ReadAbsenceViewModel extends TimeInput implements IReadAbsenceViewModel {
    absenceId?: string;
    label?: string | undefined;
    time?: number | undefined;

    constructor(data?: IReadAbsenceViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.absenceId = _data["absenceId"];
            this.label = _data["label"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): ReadAbsenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadAbsenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["absenceId"] = this.absenceId;
        data["label"] = this.label;
        data["time"] = this.time;
        super.toJSON(data);
        return data;
    }
}

export interface IReadAbsenceViewModel extends ITimeInput {
    absenceId?: string;
    label?: string | undefined;
    time?: number | undefined;
}

export class GetAbsencesByTimeSheetIdRequestModel implements IGetAbsencesByTimeSheetIdRequestModel {
    timeSheetId?: string;

    constructor(data?: IGetAbsencesByTimeSheetIdRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSheetId = _data["timeSheetId"];
        }
    }

    static fromJS(data: any): GetAbsencesByTimeSheetIdRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAbsencesByTimeSheetIdRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSheetId"] = this.timeSheetId;
        return data;
    }
}

export interface IGetAbsencesByTimeSheetIdRequestModel {
    timeSheetId?: string;
}

export class GetTimeSheetDetailResponse implements IGetTimeSheetDetailResponse {
    id?: string;
    sheetDate?: Date;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    totalTime?: number | undefined;
    totalTimeNuit?: number | undefined;
    totalAbsence?: number | undefined;
    kmPersoJustification?: string | undefined;
    tasks?: TimeSheetLineResponseModel[] | undefined;
    absences?: AbsenceLineResponseModel[] | undefined;
    prime?: number | undefined;
    isYesterdayGrandDeplacement?: boolean;

    constructor(data?: IGetTimeSheetDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sheetDate = _data["sheetDate"] ? new Date(_data["sheetDate"].toString()) : <any>undefined;
            this.panierRepas = _data["panierRepas"];
            this.grandDeplacement = _data["grandDeplacement"];
            this.tempsTrajet = _data["tempsTrajet"];
            this.tempsTrajetSurHeureTravaillees = _data["tempsTrajetSurHeureTravaillees"];
            this.kmPro = _data["kmPro"];
            this.kmPerso = _data["kmPerso"];
            this.totalTime = _data["totalTime"];
            this.totalTimeNuit = _data["totalTimeNuit"];
            this.totalAbsence = _data["totalAbsence"];
            this.kmPersoJustification = _data["kmPersoJustification"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TimeSheetLineResponseModel.fromJS(item));
            }
            if (Array.isArray(_data["absences"])) {
                this.absences = [] as any;
                for (let item of _data["absences"])
                    this.absences!.push(AbsenceLineResponseModel.fromJS(item));
            }
            this.prime = _data["prime"];
            this.isYesterdayGrandDeplacement = _data["isYesterdayGrandDeplacement"];
        }
    }

    static fromJS(data: any): GetTimeSheetDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTimeSheetDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sheetDate"] = this.sheetDate ? this.sheetDate.toISOString() : <any>undefined;
        data["panierRepas"] = this.panierRepas;
        data["grandDeplacement"] = this.grandDeplacement;
        data["tempsTrajet"] = this.tempsTrajet;
        data["tempsTrajetSurHeureTravaillees"] = this.tempsTrajetSurHeureTravaillees;
        data["kmPro"] = this.kmPro;
        data["kmPerso"] = this.kmPerso;
        data["totalTime"] = this.totalTime;
        data["totalTimeNuit"] = this.totalTimeNuit;
        data["totalAbsence"] = this.totalAbsence;
        data["kmPersoJustification"] = this.kmPersoJustification;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        if (Array.isArray(this.absences)) {
            data["absences"] = [];
            for (let item of this.absences)
                data["absences"].push(item.toJSON());
        }
        data["prime"] = this.prime;
        data["isYesterdayGrandDeplacement"] = this.isYesterdayGrandDeplacement;
        return data;
    }
}

export interface IGetTimeSheetDetailResponse {
    id?: string;
    sheetDate?: Date;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    totalTime?: number | undefined;
    totalTimeNuit?: number | undefined;
    totalAbsence?: number | undefined;
    kmPersoJustification?: string | undefined;
    tasks?: TimeSheetLineResponseModel[] | undefined;
    absences?: AbsenceLineResponseModel[] | undefined;
    prime?: number | undefined;
    isYesterdayGrandDeplacement?: boolean;
}

export abstract class InputTime implements IInputTime {
    id?: string;
    time?: number;
    comment?: string | undefined;

    constructor(data?: IInputTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): InputTime {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'InputTime' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IInputTime {
    id?: string;
    time?: number;
    comment?: string | undefined;
}

export class TimeSheetLineResponseModel extends InputTime implements ITimeSheetLineResponseModel {
    client?: string | undefined;
    projet?: string | undefined;
    projetId?: string | undefined;
    externalId?: string | undefined;
    tache?: string | undefined;
    tacheId?: string | undefined;
    heuresDeNuit?: boolean;

    constructor(data?: ITimeSheetLineResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.client = _data["client"];
            this.projet = _data["projet"];
            this.projetId = _data["projetId"];
            this.externalId = _data["externalId"];
            this.tache = _data["tache"];
            this.tacheId = _data["tacheId"];
            this.heuresDeNuit = _data["heuresDeNuit"];
        }
    }

    static fromJS(data: any): TimeSheetLineResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetLineResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client;
        data["projet"] = this.projet;
        data["projetId"] = this.projetId;
        data["externalId"] = this.externalId;
        data["tache"] = this.tache;
        data["tacheId"] = this.tacheId;
        data["heuresDeNuit"] = this.heuresDeNuit;
        super.toJSON(data);
        return data;
    }
}

export interface ITimeSheetLineResponseModel extends IInputTime {
    client?: string | undefined;
    projet?: string | undefined;
    projetId?: string | undefined;
    externalId?: string | undefined;
    tache?: string | undefined;
    tacheId?: string | undefined;
    heuresDeNuit?: boolean;
}

export class AbsenceLineResponseModel extends InputTime implements IAbsenceLineResponseModel {
    libelle?: string | undefined;

    constructor(data?: IAbsenceLineResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): AbsenceLineResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceLineResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["libelle"] = this.libelle;
        super.toJSON(data);
        return data;
    }
}

export interface IAbsenceLineResponseModel extends IInputTime {
    libelle?: string | undefined;
}

export class TimeSheetModel implements ITimeSheetModel {
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    sheetDate?: Date;
    timeSheetStatus?: TimeSheetStatus;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
    prime?: number | undefined;

    constructor(data?: ITimeSheetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.panierRepas = _data["panierRepas"];
            this.grandDeplacement = _data["grandDeplacement"];
            this.sheetDate = _data["sheetDate"] ? new Date(_data["sheetDate"].toString()) : <any>undefined;
            this.timeSheetStatus = _data["timeSheetStatus"];
            this.tempsTrajet = _data["tempsTrajet"];
            this.tempsTrajetSurHeureTravaillees = _data["tempsTrajetSurHeureTravaillees"];
            this.kmPro = _data["kmPro"];
            this.kmPerso = _data["kmPerso"];
            this.kmPersoJustification = _data["kmPersoJustification"];
            this.prime = _data["prime"];
        }
    }

    static fromJS(data: any): TimeSheetModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["panierRepas"] = this.panierRepas;
        data["grandDeplacement"] = this.grandDeplacement;
        data["sheetDate"] = this.sheetDate ? this.sheetDate.toISOString() : <any>undefined;
        data["timeSheetStatus"] = this.timeSheetStatus;
        data["tempsTrajet"] = this.tempsTrajet;
        data["tempsTrajetSurHeureTravaillees"] = this.tempsTrajetSurHeureTravaillees;
        data["kmPro"] = this.kmPro;
        data["kmPerso"] = this.kmPerso;
        data["kmPersoJustification"] = this.kmPersoJustification;
        data["prime"] = this.prime;
        return data;
    }
}

export interface ITimeSheetModel {
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    sheetDate?: Date;
    timeSheetStatus?: TimeSheetStatus;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
    prime?: number | undefined;
}

export class ReadTimeSheetViewModel implements IReadTimeSheetViewModel {
    id?: string;
    validTimeSheetId?: string | undefined;
    canBeValidate?: boolean;
    lastRefuseValidation?: ValidationViewModel | undefined;
    sheetDate?: Date;
    timeSheetStatus?: ReferentielViewModel | undefined;
    utilisateur?: UserLightViewModelWithCost | undefined;
    coutJournalier?: number | undefined;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
    total?: number | undefined;
    totalNuit?: number | undefined;
    montant?: number | undefined;
    tempsAbsences?: number | undefined;
    createdBy?: string | undefined;
    prime?: number | undefined;
    absences?: ReadAbsenceViewModel[] | undefined;
    tasks?: ReadTimeSheetInputViewModel[] | undefined;

    constructor(data?: IReadTimeSheetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validTimeSheetId = _data["validTimeSheetId"];
            this.canBeValidate = _data["canBeValidate"];
            this.lastRefuseValidation = _data["lastRefuseValidation"] ? ValidationViewModel.fromJS(_data["lastRefuseValidation"]) : <any>undefined;
            this.sheetDate = _data["sheetDate"] ? new Date(_data["sheetDate"].toString()) : <any>undefined;
            this.timeSheetStatus = _data["timeSheetStatus"] ? ReferentielViewModel.fromJS(_data["timeSheetStatus"]) : <any>undefined;
            this.utilisateur = _data["utilisateur"] ? UserLightViewModelWithCost.fromJS(_data["utilisateur"]) : <any>undefined;
            this.coutJournalier = _data["coutJournalier"];
            this.panierRepas = _data["panierRepas"];
            this.grandDeplacement = _data["grandDeplacement"];
            this.tempsTrajet = _data["tempsTrajet"];
            this.tempsTrajetSurHeureTravaillees = _data["tempsTrajetSurHeureTravaillees"];
            this.kmPro = _data["kmPro"];
            this.kmPerso = _data["kmPerso"];
            this.kmPersoJustification = _data["kmPersoJustification"];
            this.total = _data["total"];
            this.totalNuit = _data["totalNuit"];
            this.montant = _data["montant"];
            this.tempsAbsences = _data["tempsAbsences"];
            this.createdBy = _data["createdBy"];
            this.prime = _data["prime"];
            if (Array.isArray(_data["absences"])) {
                this.absences = [] as any;
                for (let item of _data["absences"])
                    this.absences!.push(ReadAbsenceViewModel.fromJS(item));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ReadTimeSheetInputViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReadTimeSheetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadTimeSheetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validTimeSheetId"] = this.validTimeSheetId;
        data["canBeValidate"] = this.canBeValidate;
        data["lastRefuseValidation"] = this.lastRefuseValidation ? this.lastRefuseValidation.toJSON() : <any>undefined;
        data["sheetDate"] = this.sheetDate ? this.sheetDate.toISOString() : <any>undefined;
        data["timeSheetStatus"] = this.timeSheetStatus ? this.timeSheetStatus.toJSON() : <any>undefined;
        data["utilisateur"] = this.utilisateur ? this.utilisateur.toJSON() : <any>undefined;
        data["coutJournalier"] = this.coutJournalier;
        data["panierRepas"] = this.panierRepas;
        data["grandDeplacement"] = this.grandDeplacement;
        data["tempsTrajet"] = this.tempsTrajet;
        data["tempsTrajetSurHeureTravaillees"] = this.tempsTrajetSurHeureTravaillees;
        data["kmPro"] = this.kmPro;
        data["kmPerso"] = this.kmPerso;
        data["kmPersoJustification"] = this.kmPersoJustification;
        data["total"] = this.total;
        data["totalNuit"] = this.totalNuit;
        data["montant"] = this.montant;
        data["tempsAbsences"] = this.tempsAbsences;
        data["createdBy"] = this.createdBy;
        data["prime"] = this.prime;
        if (Array.isArray(this.absences)) {
            data["absences"] = [];
            for (let item of this.absences)
                data["absences"].push(item.toJSON());
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReadTimeSheetViewModel {
    id?: string;
    validTimeSheetId?: string | undefined;
    canBeValidate?: boolean;
    lastRefuseValidation?: ValidationViewModel | undefined;
    sheetDate?: Date;
    timeSheetStatus?: ReferentielViewModel | undefined;
    utilisateur?: UserLightViewModelWithCost | undefined;
    coutJournalier?: number | undefined;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
    total?: number | undefined;
    totalNuit?: number | undefined;
    montant?: number | undefined;
    tempsAbsences?: number | undefined;
    createdBy?: string | undefined;
    prime?: number | undefined;
    absences?: ReadAbsenceViewModel[] | undefined;
    tasks?: ReadTimeSheetInputViewModel[] | undefined;
}

export class ValidationViewModelLight implements IValidationViewModelLight {
    id?: string;
    validationLevel?: ValidationLevel;
    validationUserId?: string;
    forceValidationUserId?: string | undefined;
    askValidationDate?: Date | undefined;
    responseDate?: Date | undefined;
    validationStatus?: ValidationStatus;
    commentaire?: string | undefined;

    constructor(data?: IValidationViewModelLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validationLevel = _data["validationLevel"];
            this.validationUserId = _data["validationUserId"];
            this.forceValidationUserId = _data["forceValidationUserId"];
            this.askValidationDate = _data["askValidationDate"] ? new Date(_data["askValidationDate"].toString()) : <any>undefined;
            this.responseDate = _data["responseDate"] ? new Date(_data["responseDate"].toString()) : <any>undefined;
            this.validationStatus = _data["validationStatus"];
            this.commentaire = _data["commentaire"];
        }
    }

    static fromJS(data: any): ValidationViewModelLight {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationViewModelLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validationLevel"] = this.validationLevel;
        data["validationUserId"] = this.validationUserId;
        data["forceValidationUserId"] = this.forceValidationUserId;
        data["askValidationDate"] = this.askValidationDate ? this.askValidationDate.toISOString() : <any>undefined;
        data["responseDate"] = this.responseDate ? this.responseDate.toISOString() : <any>undefined;
        data["validationStatus"] = this.validationStatus;
        data["commentaire"] = this.commentaire;
        return data;
    }
}

export interface IValidationViewModelLight {
    id?: string;
    validationLevel?: ValidationLevel;
    validationUserId?: string;
    forceValidationUserId?: string | undefined;
    askValidationDate?: Date | undefined;
    responseDate?: Date | undefined;
    validationStatus?: ValidationStatus;
    commentaire?: string | undefined;
}

export class ValidationViewModel extends ValidationViewModelLight implements IValidationViewModel {
    validationUtilisateur?: UserViewModel | undefined;
    forceValidationUser?: UserViewModel | undefined;

    constructor(data?: IValidationViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validationUtilisateur = _data["validationUtilisateur"] ? UserViewModel.fromJS(_data["validationUtilisateur"]) : <any>undefined;
            this.forceValidationUser = _data["forceValidationUser"] ? UserViewModel.fromJS(_data["forceValidationUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationUtilisateur"] = this.validationUtilisateur ? this.validationUtilisateur.toJSON() : <any>undefined;
        data["forceValidationUser"] = this.forceValidationUser ? this.forceValidationUser.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IValidationViewModel extends IValidationViewModelLight {
    validationUtilisateur?: UserViewModel | undefined;
    forceValidationUser?: UserViewModel | undefined;
}

export class UserViewModel extends UserLightViewModelWithCost implements IUserViewModel {
    email?: string | undefined;
    refRole?: ReferentielStringViewModel | undefined;
    role?: string | undefined;
    isSA?: boolean;
    isDeleted?: boolean;
    responsableId?: string | undefined;
    responsables?: UserViewModel[] | undefined;
    client?: ClientViewModel | undefined;
    passwordNeedSet?: boolean;
    baseSalaire?: number | undefined;
    entreprises?: EntrepriseViewModel[] | undefined;
    entrepriseConnected?: string | undefined;
    saisieFeuilleTempsDisable?: boolean;
    tagCategories?: TagCategoryViewModel[] | undefined;

    constructor(data?: IUserViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
            this.refRole = _data["refRole"] ? ReferentielStringViewModel.fromJS(_data["refRole"]) : <any>undefined;
            this.role = _data["role"];
            this.isSA = _data["isSA"];
            this.isDeleted = _data["isDeleted"];
            this.responsableId = _data["responsableId"];
            if (Array.isArray(_data["responsables"])) {
                this.responsables = [] as any;
                for (let item of _data["responsables"])
                    this.responsables!.push(UserViewModel.fromJS(item));
            }
            this.client = _data["client"] ? ClientViewModel.fromJS(_data["client"]) : <any>undefined;
            this.passwordNeedSet = _data["passwordNeedSet"];
            this.baseSalaire = _data["baseSalaire"];
            if (Array.isArray(_data["entreprises"])) {
                this.entreprises = [] as any;
                for (let item of _data["entreprises"])
                    this.entreprises!.push(EntrepriseViewModel.fromJS(item));
            }
            this.entrepriseConnected = _data["entrepriseConnected"];
            this.saisieFeuilleTempsDisable = _data["saisieFeuilleTempsDisable"];
            if (Array.isArray(_data["tagCategories"])) {
                this.tagCategories = [] as any;
                for (let item of _data["tagCategories"])
                    this.tagCategories!.push(TagCategoryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["refRole"] = this.refRole ? this.refRole.toJSON() : <any>undefined;
        data["role"] = this.role;
        data["isSA"] = this.isSA;
        data["isDeleted"] = this.isDeleted;
        data["responsableId"] = this.responsableId;
        if (Array.isArray(this.responsables)) {
            data["responsables"] = [];
            for (let item of this.responsables)
                data["responsables"].push(item.toJSON());
        }
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["passwordNeedSet"] = this.passwordNeedSet;
        data["baseSalaire"] = this.baseSalaire;
        if (Array.isArray(this.entreprises)) {
            data["entreprises"] = [];
            for (let item of this.entreprises)
                data["entreprises"].push(item.toJSON());
        }
        data["entrepriseConnected"] = this.entrepriseConnected;
        data["saisieFeuilleTempsDisable"] = this.saisieFeuilleTempsDisable;
        if (Array.isArray(this.tagCategories)) {
            data["tagCategories"] = [];
            for (let item of this.tagCategories)
                data["tagCategories"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUserViewModel extends IUserLightViewModelWithCost {
    email?: string | undefined;
    refRole?: ReferentielStringViewModel | undefined;
    role?: string | undefined;
    isSA?: boolean;
    isDeleted?: boolean;
    responsableId?: string | undefined;
    responsables?: UserViewModel[] | undefined;
    client?: ClientViewModel | undefined;
    passwordNeedSet?: boolean;
    baseSalaire?: number | undefined;
    entreprises?: EntrepriseViewModel[] | undefined;
    entrepriseConnected?: string | undefined;
    saisieFeuilleTempsDisable?: boolean;
    tagCategories?: TagCategoryViewModel[] | undefined;
}

export class EntrepriseViewModel implements IEntrepriseViewModel {
    id?: string | undefined;
    name?: string | undefined;
    logo?: string | undefined;

    constructor(data?: IEntrepriseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): EntrepriseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EntrepriseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["logo"] = this.logo;
        return data;
    }
}

export interface IEntrepriseViewModel {
    id?: string | undefined;
    name?: string | undefined;
    logo?: string | undefined;
}

export class InputTimeBase implements IInputTimeBase {
    userId?: string | undefined;
    inputDate?: Date;
    inputTime?: number | undefined;
    comment?: string | undefined;

    constructor(data?: IInputTimeBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.inputDate = _data["inputDate"] ? new Date(_data["inputDate"].toString()) : <any>undefined;
            this.inputTime = _data["inputTime"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): InputTimeBase {
        data = typeof data === 'object' ? data : {};
        let result = new InputTimeBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["inputDate"] = this.inputDate ? this.inputDate.toISOString() : <any>undefined;
        data["inputTime"] = this.inputTime;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IInputTimeBase {
    userId?: string | undefined;
    inputDate?: Date;
    inputTime?: number | undefined;
    comment?: string | undefined;
}

export class InputTimeCommand extends InputTimeBase implements IInputTimeCommand {
    taskProjectId?: string;
    isFinished?: boolean;
    heuresDeNuit?: boolean;

    constructor(data?: IInputTimeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskProjectId = _data["taskProjectId"];
            this.isFinished = _data["isFinished"];
            this.heuresDeNuit = _data["heuresDeNuit"];
        }
    }

    static fromJS(data: any): InputTimeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InputTimeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskProjectId"] = this.taskProjectId;
        data["isFinished"] = this.isFinished;
        data["heuresDeNuit"] = this.heuresDeNuit;
        super.toJSON(data);
        return data;
    }
}

export interface IInputTimeCommand extends IInputTimeBase {
    taskProjectId?: string;
    isFinished?: boolean;
    heuresDeNuit?: boolean;
}

export class TimeSheetAbsenceInput extends TimeSheetInputBase implements ITimeSheetAbsenceInput {
    absenceId?: string | undefined;
    absence?: Absence | undefined;

    constructor(data?: ITimeSheetAbsenceInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.absenceId = _data["absenceId"];
            this.absence = _data["absence"] ? Absence.fromJS(_data["absence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeSheetAbsenceInput {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetAbsenceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["absenceId"] = this.absenceId;
        data["absence"] = this.absence ? this.absence.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITimeSheetAbsenceInput extends ITimeSheetInputBase {
    absenceId?: string | undefined;
    absence?: Absence | undefined;
}

export class Absence extends UpdatableDocument implements IAbsence {
    id?: string;
    label?: string | undefined;

    constructor(data?: IAbsence) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): Absence {
        data = typeof data === 'object' ? data : {};
        let result = new Absence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        super.toJSON(data);
        return data;
    }
}

export interface IAbsence extends IUpdatableDocument {
    id?: string;
    label?: string | undefined;
}

export class InputAbsence extends InputTimeBase implements IInputAbsence {
    absenceId?: string;

    constructor(data?: IInputAbsence) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.absenceId = _data["absenceId"];
        }
    }

    static fromJS(data: any): InputAbsence {
        data = typeof data === 'object' ? data : {};
        let result = new InputAbsence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["absenceId"] = this.absenceId;
        super.toJSON(data);
        return data;
    }
}

export interface IInputAbsence extends IInputTimeBase {
    absenceId?: string;
}

export class DayTimeSheetCommand implements IDayTimeSheetCommand {
    userId?: string | undefined;
    inputDate?: Date;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;

    constructor(data?: IDayTimeSheetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.inputDate = _data["inputDate"] ? new Date(_data["inputDate"].toString()) : <any>undefined;
            this.panierRepas = _data["panierRepas"];
            this.grandDeplacement = _data["grandDeplacement"];
            this.tempsTrajet = _data["tempsTrajet"];
            this.tempsTrajetSurHeureTravaillees = _data["tempsTrajetSurHeureTravaillees"];
            this.kmPro = _data["kmPro"];
            this.kmPerso = _data["kmPerso"];
            this.kmPersoJustification = _data["kmPersoJustification"];
        }
    }

    static fromJS(data: any): DayTimeSheetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DayTimeSheetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["inputDate"] = this.inputDate ? this.inputDate.toISOString() : <any>undefined;
        data["panierRepas"] = this.panierRepas;
        data["grandDeplacement"] = this.grandDeplacement;
        data["tempsTrajet"] = this.tempsTrajet;
        data["tempsTrajetSurHeureTravaillees"] = this.tempsTrajetSurHeureTravaillees;
        data["kmPro"] = this.kmPro;
        data["kmPerso"] = this.kmPerso;
        data["kmPersoJustification"] = this.kmPersoJustification;
        return data;
    }
}

export interface IDayTimeSheetCommand {
    userId?: string | undefined;
    inputDate?: Date;
    panierRepas?: boolean | undefined;
    grandDeplacement?: boolean | undefined;
    tempsTrajet?: number | undefined;
    tempsTrajetSurHeureTravaillees?: number | undefined;
    kmPro?: number | undefined;
    kmPerso?: number | undefined;
    kmPersoJustification?: string | undefined;
}

export class InputTimeCommentCommand implements IInputTimeCommentCommand {
    comment?: string | undefined;

    constructor(data?: IInputTimeCommentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): InputTimeCommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InputTimeCommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        return data;
    }
}

export interface IInputTimeCommentCommand {
    comment?: string | undefined;
}

export class PagedResultOfReferentielAbsenceViewModel implements IPagedResultOfReferentielAbsenceViewModel {
    totalCount?: number;
    data?: ReferentielAbsenceViewModel[] | undefined;

    constructor(data?: IPagedResultOfReferentielAbsenceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReferentielAbsenceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfReferentielAbsenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfReferentielAbsenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfReferentielAbsenceViewModel {
    totalCount?: number;
    data?: ReferentielAbsenceViewModel[] | undefined;
}

export class ReferentielAbsenceViewModel implements IReferentielAbsenceViewModel {
    key?: string | undefined;
    label?: string | undefined;

    constructor(data?: IReferentielAbsenceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ReferentielAbsenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentielAbsenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        return data;
    }
}

export interface IReferentielAbsenceViewModel {
    key?: string | undefined;
    label?: string | undefined;
}

export class TypeAbsenceViewModel implements ITypeAbsenceViewModel {

    constructor(data?: ITypeAbsenceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TypeAbsenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypeAbsenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITypeAbsenceViewModel {
}

export class TypeAbsenceCommand implements ITypeAbsenceCommand {
    label?: string | undefined;

    constructor(data?: ITypeAbsenceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): TypeAbsenceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TypeAbsenceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        return data;
    }
}

export interface ITypeAbsenceCommand {
    label?: string | undefined;
}

export class UserCommand implements IUserCommand {
    userName?: string | undefined;
    email?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    password?: string | undefined;
    coutHoraire?: number | undefined;
    baseSalaire?: number | undefined;
    role?: string;
    externalId?: string | undefined;
    accessAllChantier?: boolean;
    canAddTaskOnChantier?: boolean;
    responsablesId?: string[] | undefined;
    saisieFeuilleTempsDisable?: boolean;
    tagsCategory?: string[] | undefined;

    constructor(data?: IUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.prenom = _data["prenom"];
            this.nom = _data["nom"];
            this.password = _data["password"];
            this.coutHoraire = _data["coutHoraire"];
            this.baseSalaire = _data["baseSalaire"];
            this.role = _data["role"];
            this.externalId = _data["externalId"];
            this.accessAllChantier = _data["accessAllChantier"];
            this.canAddTaskOnChantier = _data["canAddTaskOnChantier"];
            if (Array.isArray(_data["responsablesId"])) {
                this.responsablesId = [] as any;
                for (let item of _data["responsablesId"])
                    this.responsablesId!.push(item);
            }
            this.saisieFeuilleTempsDisable = _data["saisieFeuilleTempsDisable"];
            if (Array.isArray(_data["tagsCategory"])) {
                this.tagsCategory = [] as any;
                for (let item of _data["tagsCategory"])
                    this.tagsCategory!.push(item);
            }
        }
    }

    static fromJS(data: any): UserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["prenom"] = this.prenom;
        data["nom"] = this.nom;
        data["password"] = this.password;
        data["coutHoraire"] = this.coutHoraire;
        data["baseSalaire"] = this.baseSalaire;
        data["role"] = this.role;
        data["externalId"] = this.externalId;
        data["accessAllChantier"] = this.accessAllChantier;
        data["canAddTaskOnChantier"] = this.canAddTaskOnChantier;
        if (Array.isArray(this.responsablesId)) {
            data["responsablesId"] = [];
            for (let item of this.responsablesId)
                data["responsablesId"].push(item);
        }
        data["saisieFeuilleTempsDisable"] = this.saisieFeuilleTempsDisable;
        if (Array.isArray(this.tagsCategory)) {
            data["tagsCategory"] = [];
            for (let item of this.tagsCategory)
                data["tagsCategory"].push(item);
        }
        return data;
    }
}

export interface IUserCommand {
    userName?: string | undefined;
    email?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    password?: string | undefined;
    coutHoraire?: number | undefined;
    baseSalaire?: number | undefined;
    role?: string;
    externalId?: string | undefined;
    accessAllChantier?: boolean;
    canAddTaskOnChantier?: boolean;
    responsablesId?: string[] | undefined;
    saisieFeuilleTempsDisable?: boolean;
    tagsCategory?: string[] | undefined;
}

export class PagedResultOfUserViewModel implements IPagedResultOfUserViewModel {
    totalCount?: number;
    data?: UserViewModel[] | undefined;

    constructor(data?: IPagedResultOfUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfUserViewModel {
    totalCount?: number;
    data?: UserViewModel[] | undefined;
}

export class LightValidSheetViewModel implements ILightValidSheetViewModel {
    id?: string;
    numSemaine?: number;
    canBeValidate?: boolean;
    utilisateurTimeSheetId?: string;
    utilisateurTimeSheet?: UserLightViewModel | undefined;
    startDate?: Date;
    validationStatus?: ValidationStatus;
    usersValidation?: ValidationViewModelLight[] | undefined;

    constructor(data?: ILightValidSheetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numSemaine = _data["numSemaine"];
            this.canBeValidate = _data["canBeValidate"];
            this.utilisateurTimeSheetId = _data["utilisateurTimeSheetId"];
            this.utilisateurTimeSheet = _data["utilisateurTimeSheet"] ? UserLightViewModel.fromJS(_data["utilisateurTimeSheet"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.validationStatus = _data["validationStatus"];
            if (Array.isArray(_data["usersValidation"])) {
                this.usersValidation = [] as any;
                for (let item of _data["usersValidation"])
                    this.usersValidation!.push(ValidationViewModelLight.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LightValidSheetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LightValidSheetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numSemaine"] = this.numSemaine;
        data["canBeValidate"] = this.canBeValidate;
        data["utilisateurTimeSheetId"] = this.utilisateurTimeSheetId;
        data["utilisateurTimeSheet"] = this.utilisateurTimeSheet ? this.utilisateurTimeSheet.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["validationStatus"] = this.validationStatus;
        if (Array.isArray(this.usersValidation)) {
            data["usersValidation"] = [];
            for (let item of this.usersValidation)
                data["usersValidation"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILightValidSheetViewModel {
    id?: string;
    numSemaine?: number;
    canBeValidate?: boolean;
    utilisateurTimeSheetId?: string;
    utilisateurTimeSheet?: UserLightViewModel | undefined;
    startDate?: Date;
    validationStatus?: ValidationStatus;
    usersValidation?: ValidationViewModelLight[] | undefined;
}

export class ValidSheetExpandViewModel extends LightValidSheetViewModel implements IValidSheetExpandViewModel {
    timeSheets?: _ReadTimeSheetViewModel[] | undefined;
    totalTime?: number;
    totalTimeNuit?: number;
    totalPanierRepas?: number;
    totalGdDeplacement?: number;
    totalKmPerso?: number;
    totalKmPro?: number;
    totalTrajets?: number;
    totalTrajetsHeuresTravaillees?: number;
    totalAbsences?: number;

    constructor(data?: IValidSheetExpandViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["timeSheets"])) {
                this.timeSheets = [] as any;
                for (let item of _data["timeSheets"])
                    this.timeSheets!.push(_ReadTimeSheetViewModel.fromJS(item));
            }
            this.totalTime = _data["totalTime"];
            this.totalTimeNuit = _data["totalTimeNuit"];
            this.totalPanierRepas = _data["totalPanierRepas"];
            this.totalGdDeplacement = _data["totalGdDeplacement"];
            this.totalKmPerso = _data["totalKmPerso"];
            this.totalKmPro = _data["totalKmPro"];
            this.totalTrajets = _data["totalTrajets"];
            this.totalTrajetsHeuresTravaillees = _data["totalTrajetsHeuresTravaillees"];
            this.totalAbsences = _data["totalAbsences"];
        }
    }

    static fromJS(data: any): ValidSheetExpandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidSheetExpandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timeSheets)) {
            data["timeSheets"] = [];
            for (let item of this.timeSheets)
                data["timeSheets"].push(item.toJSON());
        }
        data["totalTime"] = this.totalTime;
        data["totalTimeNuit"] = this.totalTimeNuit;
        data["totalPanierRepas"] = this.totalPanierRepas;
        data["totalGdDeplacement"] = this.totalGdDeplacement;
        data["totalKmPerso"] = this.totalKmPerso;
        data["totalKmPro"] = this.totalKmPro;
        data["totalTrajets"] = this.totalTrajets;
        data["totalTrajetsHeuresTravaillees"] = this.totalTrajetsHeuresTravaillees;
        data["totalAbsences"] = this.totalAbsences;
        super.toJSON(data);
        return data;
    }
}

export interface IValidSheetExpandViewModel extends ILightValidSheetViewModel {
    timeSheets?: _ReadTimeSheetViewModel[] | undefined;
    totalTime?: number;
    totalTimeNuit?: number;
    totalPanierRepas?: number;
    totalGdDeplacement?: number;
    totalKmPerso?: number;
    totalKmPro?: number;
    totalTrajets?: number;
    totalTrajetsHeuresTravaillees?: number;
    totalAbsences?: number;
}

export class _ReadTimeSheetViewModel implements I_ReadTimeSheetViewModel {
    id?: string | undefined;
    sheetDate?: Date;

    constructor(data?: I_ReadTimeSheetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sheetDate = _data["sheetDate"] ? new Date(_data["sheetDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): _ReadTimeSheetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new _ReadTimeSheetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sheetDate"] = this.sheetDate ? this.sheetDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface I_ReadTimeSheetViewModel {
    id?: string | undefined;
    sheetDate?: Date;
}

export class ValidTimeSheetViewModel extends LightValidSheetViewModel implements IValidTimeSheetViewModel {
    userValidationStatuts?: ValidationStatus;
    respValidationStatuts?: ValidationStatus | undefined;
    comValidationStatuts?: ValidationStatus | undefined;
    adminValidationStatuts?: ValidationStatus | undefined;
    totalTime?: number;
    totalTimeNuit?: number;
    totalTrajets?: number;
    totalTrajetsHeuresTravaillees?: number;
    totalAbsences?: number;

    constructor(data?: IValidTimeSheetViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userValidationStatuts = _data["userValidationStatuts"];
            this.respValidationStatuts = _data["respValidationStatuts"];
            this.comValidationStatuts = _data["comValidationStatuts"];
            this.adminValidationStatuts = _data["adminValidationStatuts"];
            this.totalTime = _data["totalTime"];
            this.totalTimeNuit = _data["totalTimeNuit"];
            this.totalTrajets = _data["totalTrajets"];
            this.totalTrajetsHeuresTravaillees = _data["totalTrajetsHeuresTravaillees"];
            this.totalAbsences = _data["totalAbsences"];
        }
    }

    static fromJS(data: any): ValidTimeSheetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidTimeSheetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userValidationStatuts"] = this.userValidationStatuts;
        data["respValidationStatuts"] = this.respValidationStatuts;
        data["comValidationStatuts"] = this.comValidationStatuts;
        data["adminValidationStatuts"] = this.adminValidationStatuts;
        data["totalTime"] = this.totalTime;
        data["totalTimeNuit"] = this.totalTimeNuit;
        data["totalTrajets"] = this.totalTrajets;
        data["totalTrajetsHeuresTravaillees"] = this.totalTrajetsHeuresTravaillees;
        data["totalAbsences"] = this.totalAbsences;
        super.toJSON(data);
        return data;
    }
}

export interface IValidTimeSheetViewModel extends ILightValidSheetViewModel {
    userValidationStatuts?: ValidationStatus;
    respValidationStatuts?: ValidationStatus | undefined;
    comValidationStatuts?: ValidationStatus | undefined;
    adminValidationStatuts?: ValidationStatus | undefined;
    totalTime?: number;
    totalTimeNuit?: number;
    totalTrajets?: number;
    totalTrajetsHeuresTravaillees?: number;
    totalAbsences?: number;
}

export class ValidationListCommand implements IValidationListCommand {
    numSemaine?: number;
    startDate?: Date;
    users?: string[] | undefined;
    endDate?: Date;
    validationStatus?: ValidationStatus | undefined;

    constructor(data?: IValidationListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numSemaine = _data["numSemaine"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.validationStatus = _data["validationStatus"];
        }
    }

    static fromJS(data: any): ValidationListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numSemaine"] = this.numSemaine;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["validationStatus"] = this.validationStatus;
        return data;
    }
}

export interface IValidationListCommand {
    numSemaine?: number;
    startDate?: Date;
    users?: string[] | undefined;
    endDate?: Date;
    validationStatus?: ValidationStatus | undefined;
}

export class UserValidationTimeSheetCommand implements IUserValidationTimeSheetCommand {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IUserValidationTimeSheetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserValidationTimeSheetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserValidationTimeSheetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserValidationTimeSheetCommand {
    startDate?: Date;
    endDate?: Date;
}

export class ValidationByIdCommand implements IValidationByIdCommand {
    userId?: string;
    validationId?: string;
    validationStatus?: ValidationStatus | undefined;
    commentaire?: string | undefined;

    constructor(data?: IValidationByIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.validationId = _data["validationId"];
            this.validationStatus = _data["validationStatus"];
            this.commentaire = _data["commentaire"];
        }
    }

    static fromJS(data: any): ValidationByIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationByIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["validationId"] = this.validationId;
        data["validationStatus"] = this.validationStatus;
        data["commentaire"] = this.commentaire;
        return data;
    }
}

export interface IValidationByIdCommand {
    userId?: string;
    validationId?: string;
    validationStatus?: ValidationStatus | undefined;
    commentaire?: string | undefined;
}

export class UserContext implements IUserContext {
    token?: string | undefined;
    userId?: string | undefined;
    passwordNeedSet?: boolean;
    entreprises?: EntrepriseViewModel[] | undefined;

    constructor(data?: IUserContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.userId = _data["userId"];
            this.passwordNeedSet = _data["passwordNeedSet"];
            if (Array.isArray(_data["entreprises"])) {
                this.entreprises = [] as any;
                for (let item of _data["entreprises"])
                    this.entreprises!.push(EntrepriseViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserContext {
        data = typeof data === 'object' ? data : {};
        let result = new UserContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["userId"] = this.userId;
        data["passwordNeedSet"] = this.passwordNeedSet;
        if (Array.isArray(this.entreprises)) {
            data["entreprises"] = [];
            for (let item of this.entreprises)
                data["entreprises"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserContext {
    token?: string | undefined;
    userId?: string | undefined;
    passwordNeedSet?: boolean;
    entreprises?: EntrepriseViewModel[] | undefined;
}

export class FirstConnexionResponse implements IFirstConnexionResponse {
    passwordResetToken?: string | undefined;
    userId?: string | undefined;
    passwordNeedSet?: boolean;

    constructor(data?: IFirstConnexionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordResetToken = _data["passwordResetToken"];
            this.userId = _data["userId"];
            this.passwordNeedSet = _data["passwordNeedSet"];
        }
    }

    static fromJS(data: any): FirstConnexionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FirstConnexionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordResetToken"] = this.passwordResetToken;
        data["userId"] = this.userId;
        data["passwordNeedSet"] = this.passwordNeedSet;
        return data;
    }
}

export interface IFirstConnexionResponse {
    passwordResetToken?: string | undefined;
    userId?: string | undefined;
    passwordNeedSet?: boolean;
}

export class LoginCommand implements ILoginCommand {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginCommand {
    username?: string | undefined;
    password?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class CreatePasswordViewModel implements ICreatePasswordViewModel {
    password!: string;
    confirmPassword?: string | undefined;
    userId?: string | undefined;

    constructor(data?: ICreatePasswordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreatePasswordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePasswordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICreatePasswordViewModel {
    password: string;
    confirmPassword?: string | undefined;
    userId?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}